// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T23:20:12.536Z
// Property: The Majestic (ID: 6767906449167324)
// Collections: 14 amenities, 18 floorplans (live), 43 photos, 76 POIs, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167324",
  "property_external_id": "1860323",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/condos/wenatchee-wa-98801/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Majestic+Apartment+Homes/data=!4m2!3m1!1s0x0:0xbd041c02e32cb0c0?sa=X&ved=2ahUKEwiz7bvo782TAxXlH0QIHaO-JocQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "53528450118",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-majestic",
  "property_name": "The Majestic",
  "property_website_url": "https://www.majesticapartmenthomes.com/",
  "property_domain": "https://www.majesticapartmenthomes.com/",
  "property_address": "201 S Mission St",
  "property_full_address": "201 S Mission St, Wenatchee, WA 98801",
  "property_address_1": "201 S Mission St",
  "property_address_2": null,
  "property_address_city": "Wenatchee",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98801",
  "property_address_country": "US",
  "property_address_county": "Chelan County",
  "property_neighborhood_address": null,
  "property_address_latitude": "47.4216795",
  "property_address_longitude": "-120.3101021",
  "property_email": "majestic@weidner.com",
  "property_phone": "(509) 470-7438",
  "property_call_tracking_phone": "509-210-8195",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to The Majestic in Wenatchee, WA, where modern living meets leisure. Choose from stylish studio to spacious three-bedroom floor plans. Enjoy our state-of-the-art fitness center, unwind in the grand club room, or soak up the views on the rooftop deck. Find your new home today—browse availability or schedule a tour!",
  "property_long_description": "The Majestic brings the best of Wenatchee to your doorstep.Nestled in the heart of Wenatchee, you'll live within walking distance of thearea's best restaurants, retailers, natural attractions, and entertainmentofferings.           Pre-lease your new apartment at The Majestic for Summer 2027!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e3bea-41d8-722b-b275-d2ac9af9fc00.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of a modern apartment building with balconies and street.",
    "public_id": "019e3bea-41d8-722b-b275-d2ac9af9fc00",
    "storage_key": "property/6767906449167324/019e3bea-41d8-722b-b275-d2ac9af9fc00.webp",
    "width": 1920,
    "height": 702
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "28",
  "property_fees_deposit_info": "Security deposit: $200",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "75",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://majesticapartmenthomes.securecafe.com/onlineleasing/the-majestic2/floorplans.aspx",
  "property_resident_portal_url": "https://majesticapartmenthomes.securecafenet.com/residentservices/the-majestic2/userlogin",
  "property_apply_now_url": "https://majesticapartmenthomes.securecafe.com/onlineleasing/the-majestic2/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e3be9-997a-71cc-bbc1-54ab2125b397.webp",
  "property_primary_logo_media": {
    "alt_text": "The Majestic logo",
    "public_id": "019e3be9-997a-71cc-bbc1-54ab2125b397",
    "storage_key": "property/6767906449167324/019e3be9-997a-71cc-bbc1-54ab2125b397.webp",
    "width": 512,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a5-a20c-77cb-a250-4cf1dc64e646.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Love Notes logo",
    "public_id": "019e64a5-a20c-77cb-a250-4cf1dc64e646",
    "storage_key": "property/6767906449167324/019e64a5-a20c-77cb-a250-4cf1dc64e646.webp",
    "width": 512,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a5-9768-7779-8220-3c57b267eb1c.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Love Notes logo",
    "public_id": "019e64a5-9768-7779-8220-3c57b267eb1c",
    "storage_key": "property/6767906449167324/019e64a5-9768-7779-8220-3c57b267eb1c.webp",
    "width": 512,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#575757",
  "property_secondary_color": "#debb66",
  "property_font_color": "#ffffff",
  "property_color_4": "#957d69",
  "property_color_3": "#ffffff",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "402 - 1586",
  "property_sqft_min": "402",
  "property_sqft_max": "1586",
  "property_price_range": "1570 - 4225",
  "property_price_min": "1570",
  "property_price_max": "4225",
  "property_available_units": 64,
  "property_facebook_url": "https://www.facebook.com/TheMajesticApartmentHomes",
  "property_instagram_url": "https://www.instagram.com/themajesticapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJja_Llo7Nm1QRwLAs4wIcBL0",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Majestic",
  "property_home_romance_title": "Embrace a Life You’ll Love at Our Apartment Community",
  "property_home_amenities_blurb": "Welcome to The Majestic in Wenatchee, WA, where comfort meets modern living. Choose from our thoughtfully designed studios to spacious three-bedroom apartments. Enjoy our state-of-the-art fitness center, unwind in the grand club room, or savor breathtaking views from the rooftop deck. Your new home awaits—experience the extraordinary.",
  "property_home_floorplans_blurb": "At The Majestic in beautiful Wenatchee, WA, diverse floor plans ranging from cozy studios to spacious three-bedroom homes are designed to fit your lifestyle. Each apartment offers modern amenities and scenic views. Browse our available options and find the perfect floor plan that meets all your living needs today!",
  "property_home_gallery_blurb": "At The Majestic in Wenatchee, WA, your dream lifestyle awaits. Choose from spacious studio to three-bedroom floor plans, complemented by a state-of-the-art fitness center and a grand club room. Unwind on the rooftop deck with stunning views, lounge seating, and grills. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to The Majestic, your serene sanctuary in Wenatchee, WA. Here, vibrant community life meets nature's beauty, with nearby gems like Wenatchee Riverfront Park, ohme Gardens, and the scenic Apple Capital Recreational Loop Trail. Engage with local culture at the Numerica Performing Arts Center, all just steps from your front door.",
  "property_home_reviews_blurb": "At The Majestic in Wenatchee, WA, residents rave about their experience, noting it's “the perfect blend of comfort and community.” Embrace a lifestyle where vibrant living meets stunning surroundings. See what our residents have to say about living at our community and experience the magic for yourself!",
  "property_neighborhood_blurb": "Nestled in the heart of Wenatchee, The Majestic offers easy access to vibrant cultural gems like the Numerica Performing Arts Center and the Wenatchee Valley Museum. Enjoy outdoor adventures at Wenatchee Riverfront Park or explore the trails at Squilchuck State Park. Unveil the richness of your new neighborhood today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At The Majestic in Wenatchee, WA, elevate your lifestyle with our diverse floor plans—cozy studios, spacious two-bedroom apartments, and penthouse living.</p>",
  "property_applynow_blurb": "Elevate your lifestyle at The Majestic in Wenatchee, WA, where modern floor plans—ranging from cozy studios to spacious three bedrooms—meet luxurious amenities. Unwind in the grand club room or host gatherings on the rooftop deck. Your perfect home awaits; lease online today and embrace upscale living!",
  "property_contactus_blurb": "At The Majestic in Wenatchee, WA, our diverse floor plans cater to every lifestyle, from cozy studios to spacious three-bedroom apartments. Each home is designed with you in mind. Have questions? Our leasing team is ready to assist—reach out today and unveil your ideal living space!",
  "property_faqs_blurb": "At The Majestic in scenic Wenatchee, WA, explore our diverse floor plans from cozy studios to spacious three-bedroom apartments, tailored for every lifestyle. Curious about community living? Browse our FAQs page for answers to all your questions and discover what makes The Majestic your perfect home.",
  "property_floorplans_blurb": "At The Majestic in Wenatchee, WA, your ideal living space awaits. Whether you crave the cozy charm of a studio or need the expansive comfort of a three-bedroom, our diverse floor plans cater to every lifestyle. Browse our selection and find the perfect apartment home tailored just for you!",
  "property_gallery_blurb": "At The Majestic in Wenatchee, WA, envision your ideal lifestyle amidst stunning studio, one, two, and three-bedroom apartments. Unwind in our grand club room, energize in the state-of-the-art fitness center, or savor breathtaking views from the rooftop deck. Picture yourself living here in luxury and comfort today!",
  "property_interactivemap_blurb": "At The Majestic in Wenatchee, WA, you’ll find a range of thoughtfully designed floor plans—studio to three-bedroom—that suit your lifestyle. Enjoy premium amenities, including a state-of-the-art fitness center and a rooftop deck perfect for sunsets. Use our interactive community map to find your next home today!",
  "property_pets_blurb": "Welcome to The Majestic in Wenatchee, WA, where comfort meets elegance. Our pet-friendly community invites you to share your home with up to three furry companions. Enjoy spacious living areas, lush landscapes, and a vibrant neighborhood—all designed for your lifestyle. Unleash joy in every corner of our majestic retreat!",
  "property_referafriend_blurb": "At The Majestic in Wenatchee, WA, our diverse floor plans—ranging from cozy studios to spacious three-bedroom apartments—cater to every lifestyle. Celebrate friendship and community by referring a friend today; great neighbors make for an unforgettable living experience! Join us and build lasting connections in your new home.",
  "property_residentaccess_blurb": "Welcome to The Majestic in Wenatchee, WA, where comfort meets convenience. Choose from our thoughtfully designed studio to three-bedroom floor plans that cater to every lifestyle. Current residents, log in to your portal for hassle-free rent payments, maintenance requests, and everything you need to enjoy your home fully!",
  "property_reviews_blurb": "At The Majestic in Wenatchee, WA, residents rave about their experience: \"The community's welcoming atmosphere truly feels like home.\" Dive into our reviews to uncover heartfelt stories and see why our neighbors cherish life at The Majestic. Join a community where your voice matters!",
  "property_created_at": "1774994060821",
  "property_scheduletour_blurb": "At The Majestic in Wenatchee, WA, each thoughtfully designed studio, one, two, and three-bedroom apartment offers a unique blend of comfort and style. Ready to experience a vibrant community? Schedule a tour today and hear firsthand what our residents love about calling The Majestic home!",
  "property_thankyou_blurb": "Thank you for reaching out to The Majestic in Wenatchee, WA! Your interest in our diverse floor plans, ranging from studio to three-bedroom options, is appreciated. Get ready to elevate your living experience—our team will be in touch soon to guide you on your journey to a new home.",
  "property_virtualtours_blurb": "Step into The Majestic in Wenatchee, WA, where your ideal living space awaits. From cozy studios to spacious three-bedroom layouts, our thoughtfully designed apartments cater to every lifestyle. Dive into our virtual tour and envision your next home today!",
  "property_copyright": "2026 All Rights Reserved. The Majestic",
  "property_seo_title_home": "The Majestic |  Apartments in Wenatchee, WA",
  "property_seo_description_home": "Discover luxury at The Majestic in Wenatchee, WA! Enjoy spacious layouts, a modern fitness center, and a rooftop deck. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Wenatchee, WA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at The Majestic in Wenatchee, WA! Choose from stylish studios to spacious three-bedroom apartments. Browse our floor plans now!",
  "property_seo_title_amenities": "Amenities | Wenatchee, WA Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury living at The Majestic in Wenatchee, WA, with a fitness center, grand club room, and rooftop lounge—your perfect oasis!",
  "property_seo_title_gallery": "Gallery | Apartments in Wenatchee, WA",
  "property_seo_description_gallery": "Capture the beauty of The Majestic in Wenatchee, WA. Picture your life among stunning spaces, a rooftop retreat, and top-tier amenities waiting for you!",
  "property_seo_title_virtualtours": "Virtual Tours | The Majestic Apartments",
  "property_seo_description_virtualtours": "Experience the charm of The Majestic in Wenatchee, WA! Take a virtual tour of our stunning studio, one, two, and three-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | The Majestic Apartments",
  "property_seo_description_interactivemap": "Find your perfect apartment at The Majestic in Wenatchee, WA. Use our interactive map to explore spacious floor plans and exceptional amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Wenatchee, WA",
  "property_seo_description_neighborhood": "Uncover the charm of Wenatchee, WA! The Majestic's vibrant neighborhood invites you to savor local favorites and hidden gems just steps from home.",
  "property_seo_title_contact": "Contact Us | The Majestic",
  "property_seo_description_contact": "Experience the charm of The Majestic in Wenatchee, WA. From studios to three bedrooms, our leasing team is here to answer your questions—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Wenatchee, WA",
  "property_seo_description_faqs": "Uncover all your questions about The Majestic in Wenatchee, WA. From floor plans to amenities, our FAQs page has the answers you seek. Join our community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Wenatchee, WA",
  "property_seo_description_reviews": "Experience life at The Majestic in Wenatchee, WA! Check out resident reviews and learn about our fitness center, grand club room, and rooftop lounge.",
  "property_seo_title_applynow": "Apply Now | Apartments in Wenatchee, WA",
  "property_seo_description_applynow": "Experience luxury living at The Majestic in Wenatchee, WA. Choose stylish studios or spacious three-bedroom apartments. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | The Majestic",
  "property_seo_description_residentaccess": "Access The Majestic's resident portal for easy rent payments, maintenance requests, and community updates in beautiful Wenatchee, WA. Your comfort awaits!",
  "property_seo_title_referafriend": "Refer A Friend | The Majestic",
  "property_seo_description_referafriend": "Share the joy of living at The Majestic! Refer a friend to our Wenatchee community and enjoy great neighbors and exclusive rewards together!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Majestic",
  "property_seo_description_scheduletour": "Experience luxury at The Majestic in Wenatchee, WA! Schedule your tour today for modern living with stunning views and vibrant community life.",
  "property_seo_title_privacy": "Privacy Policy | The Majestic",
  "property_seo_description_privacy": "At The Majestic in Wenatchee, WA, your privacy matters. Learn how we protect your personal information. Read our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | The Majestic",
  "property_seo_description_accessibility": "Experience true digital inclusion at The Majestic in Wenatchee, WA. Our commitment to accessibility ensures everyone feels at home. Join us today!",
  "property_seo_title_sitemap": "Sitemap | The Majestic",
  "property_seo_description_sitemap": "Unravel the charm of The Majestic in Wenatchee, WA! Navigate our sitemap to explore amenities, floor plans, and lifestyle offerings designed just for you.",
  "property_seo_title_thankyou": "Thank You | The Majestic",
  "property_seo_description_thankyou": "Thank you for reaching out! A member of The Majestic team in Wenatchee will connect soon to help you find your perfect home. Stay tuned for exciting updates!",
  "property_seo_title_pets": "Pet Policy | Apartments in Wenatchee, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793119463082",
  "amenities": [
    {
      "id": "custom_a9600199-2f1d-4391-a071-31af7c63799f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "external_id": "false",
      "title": "High-End Finishes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_37c9d250-97e5-4416-b906-baa198b418fb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Whirlpool Appliance Package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2fde3387-bc27-4373-8dca-258dab43c976",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_479d1582-0c5d-4452-96f0-1d8dedcdca60",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_99ef0489-44d7-4d8b-887f-567adde8bfc1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "external_id": "false",
      "title": "Keyless Entry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c46a80bc-201e-4339-82e6-4b2b4588fa59",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "external_id": "false",
      "title": "Smart Thermostats",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f5daff2a-c8c3-4901-8ad8-cc08bcd583ff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Fiber Internet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d5ff5de5-afa7-4b3c-9a66-2e5318dc28b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "external_id": "false",
      "title": "Top-Floor Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6362e699-723b-431e-8c21-9fd3d63444d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "external_id": "false",
      "title": "Club Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a3ad8acb-d80f-4e92-82f1-0dccca4f4577",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Deck with Expansive Views of Wenatchee River and Foothills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7d926a72-c81f-43f4-9e50-90addfef47ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "external_id": "false",
      "title": "Secure-Access Lobby",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f608d1a8-5d1d-43b7-95e4-ec9aaf347160",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "external_id": "false",
      "title": "Dedicated Package Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_274d5822-3fa6-4e7d-9cf4-92ad15adf273",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d06c936d-dcdf-4ade-a100-909e80bdc3b2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Latte Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_3dbdfa60-8328-45bc-a73e-66370e219fad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a4-039e-772b-ab64-d3b5cd27b57a.webp",
      "image_media": {
        "alt_text": "Modern living room with plush seating, contemporary coffee table, and decorative wall paneling.",
        "public_id": "019e64a4-039e-772b-ab64-d3b5cd27b57a",
        "storage_key": "property/6767906449167324/019e64a4-039e-772b-ab64-d3b5cd27b57a.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Experience elegant living in this stylish apartment's living space, featuring comfortable seating and a sophisticated ambiance.",
      "link": "",
      "alt_text": "Modern living room with plush seating, contemporary coffee table, and decorative wall paneling.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eb1f27f2-c7f4-49fd-99be-50cb8d7b3e41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a4-0c8a-71af-bf91-8ee8b6531042.webp",
      "image_media": {
        "alt_text": "Modern community lounge with a long marble dining table, chairs, fireplace, and a sectional sofa.",
        "public_id": "019e64a4-0c8a-71af-bf91-8ee8b6531042",
        "storage_key": "property/6767906449167324/019e64a4-0c8a-71af-bf91-8ee8b6531042.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Gather in the stylish community lounge, featuring a grand dining table, cozy seating area, and elegant fireplace, perfect for socializing.",
      "link": "",
      "alt_text": "Modern community lounge with a long marble dining table, chairs, fireplace, and a sectional sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_98332eba-e492-4128-8013-27ee0cb8b7d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a4-02ec-7249-8913-e7d565fc99aa.webp",
      "image_media": {
        "alt_text": "Modern kitchen and lounge area with bar seating, communal tables, and a fireplace.",
        "public_id": "019e64a4-02ec-7249-8913-e7d565fc99aa",
        "storage_key": "property/6767906449167324/019e64a4-02ec-7249-8913-e7d565fc99aa.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy our stylish communal kitchen and lounge, perfect for socializing or working, featuring ample seating and a cozy fireplace.",
      "link": "",
      "alt_text": "Modern kitchen and lounge area with bar seating, communal tables, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6f21b1b0-f6db-4f47-9796-6da40589e626",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a4-0158-744a-ad2d-d9e507ebe64f.webp",
      "image_media": {
        "alt_text": "Modern communal kitchen and dining area with island, bar stools, and large dining table.",
        "public_id": "019e64a4-0158-744a-ad2d-d9e507ebe64f",
        "storage_key": "property/6767906449167324/019e64a4-0158-744a-ad2d-d9e507ebe64f.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy gatherings in our stylish communal kitchen and dining space, featuring a large island, comfortable seating, and a sophisticated design.",
      "link": "",
      "alt_text": "Modern communal kitchen and dining area with island, bar stools, and large dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4820df64-01e9-4184-a210-73beb3ab71d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a4-086f-775a-80db-95210eea4efb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with large island, bar stools, and sleek cabinetry.",
        "public_id": "019e64a4-086f-775a-80db-95210eea4efb",
        "storage_key": "property/6767906449167324/019e64a4-086f-775a-80db-95210eea4efb.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "A stylish kitchen featuring a spacious island with bar seating, dark wood cabinetry, and decorative shelving. Perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with large island, bar stools, and sleek cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_35e6a731-618d-4625-913e-20a1807d4426",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a4-01ac-77eb-8569-ee96cfda93cd.webp",
      "image_media": {
        "alt_text": "Modern community lounge with fireplace, dining table, and seating area.",
        "public_id": "019e64a4-01ac-77eb-8569-ee96cfda93cd",
        "storage_key": "property/6767906449167324/019e64a4-01ac-77eb-8569-ee96cfda93cd.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy our stylish community lounge featuring a cozy fireplace, a large communal dining table, and comfortable seating areas perfect for relaxation or socializing.",
      "link": "",
      "alt_text": "Modern community lounge with fireplace, dining table, and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a0ff2c72-2893-432c-bbe1-abbc183ed0bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a4-0074-72c6-bfdd-217f7e0e5d4a.webp",
      "image_media": {
        "alt_text": "People exercising in a modern fitness studio with mirrors and workout equipment.",
        "public_id": "019e64a4-0074-72c6-bfdd-217f7e0e5d4a",
        "storage_key": "property/6767906449167324/019e64a4-0074-72c6-bfdd-217f7e0e5d4a.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness studio offers a dedicated space for residents to achieve their wellness goals with ample equipment and natural light.",
      "link": "",
      "alt_text": "People exercising in a modern fitness studio with mirrors and workout equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f9397096-1f63-4bc0-b1a8-dfb8f78e6ad2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-f3d9-7201-9191-423b58f12458.webp",
      "image_media": {
        "alt_text": "Interior view of a modern apartment building lobby with a yoga area and water fountain.",
        "public_id": "019e64a3-f3d9-7201-9191-423b58f12458",
        "storage_key": "property/6767906449167324/019e64a3-f3d9-7201-9191-423b58f12458.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Experience wellness and convenience in our stunning apartment lobby, featuring a dedicated yoga space and a refreshing water fountain for residents.",
      "link": "",
      "alt_text": "Interior view of a modern apartment building lobby with a yoga area and water fountain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4addbd21-419c-4571-98ad-041297a47b2b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-e9f5-761c-81ed-6bcad46eaff8.webp",
      "image_media": {
        "alt_text": "Lobby seating area with plush green sofa, accent chairs, and decorative wall panels.",
        "public_id": "019e64a3-e9f5-761c-81ed-6bcad46eaff8",
        "storage_key": "property/6767906449167324/019e64a3-e9f5-761c-81ed-6bcad46eaff8.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby seating area, featuring comfortable sofas, elegant chairs, and sophisticated decor.",
      "link": "",
      "alt_text": "Lobby seating area with plush green sofa, accent chairs, and decorative wall panels.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a7eff240-ec4b-42cc-a966-960a846720ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-f05f-70fb-94ca-8936ed5ac71f.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019e64a3-f05f-70fb-94ca-8936ed5ac71f",
        "storage_key": "property/6767906449167324/019e64a3-f05f-70fb-94ca-8936ed5ac71f.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a wide range of cardio and strength training equipment for residents to enjoy.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_233f8eea-84ac-40e3-b64d-ff1abbd91b27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-eea9-7779-8fbd-4037180ef106.webp",
      "image_media": {
        "alt_text": "Fitness center with weight racks, dumbbells, and benches.",
        "public_id": "019e64a3-eea9-7779-8fbd-4037180ef106",
        "storage_key": "property/6767906449167324/019e64a3-eea9-7779-8fbd-4037180ef106.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring free weights, squat racks, and cardio equipment for a comprehensive workout experience.",
      "link": "",
      "alt_text": "Fitness center with weight racks, dumbbells, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_304baccb-a201-4e2b-b8b9-8a0166865b36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-e5e5-723f-94b6-4aa7c409d917.webp",
      "image_media": {
        "alt_text": "Modern communal lounge with large tables, bar seating, and abstract art.",
        "public_id": "019e64a3-e5e5-723f-94b6-4aa7c409d917",
        "storage_key": "property/6767906449167324/019e64a3-e5e5-723f-94b6-4aa7c409d917.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Enjoy a stylish and comfortable communal lounge, perfect for socializing or working remotely. Features modern decor, ample seating, and a wet bar area.",
      "link": "",
      "alt_text": "Modern communal lounge with large tables, bar seating, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_59157fdb-310b-4354-8248-9b58fe267ec2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-eb9e-760a-ba10-fa0a1340c05e.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, and weight equipment.",
        "public_id": "019e64a3-eb9e-760a-ba10-fa0a1340c05e",
        "storage_key": "property/6767906449167324/019e64a3-eb9e-760a-ba10-fa0a1340c05e.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines and free weights.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, and weight equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0597f56f-8593-4c4e-a7d3-701cb3ca562d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-d9ed-719e-bb3b-348a95f282fc.webp",
      "image_media": {
        "alt_text": "Elegant lobby with seating area, fireplace, and reception desk.",
        "public_id": "019e64a3-d9ed-719e-bb3b-348a95f282fc",
        "storage_key": "property/6767906449167324/019e64a3-d9ed-719e-bb3b-348a95f282fc.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Experience luxury living in our beautifully designed lobby, featuring a cozy fireplace, comfortable seating, and a sophisticated reception area.",
      "link": "",
      "alt_text": "Elegant lobby with seating area, fireplace, and reception desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4d0dc4b0-550b-43ea-860d-c085bf0c12c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-d9ad-766f-aafa-b12b43ffe828.webp",
      "image_media": {
        "alt_text": "Modern lobby with fireplace, bookshelves, and seating area.",
        "public_id": "019e64a3-d9ad-766f-aafa-b12b43ffe828",
        "storage_key": "property/6767906449167324/019e64a3-d9ad-766f-aafa-b12b43ffe828.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Experience luxury in our beautifully designed lobby, featuring a cozy fireplace, elegant bookshelves, and comfortable seating for residents and guests.",
      "link": "",
      "alt_text": "Modern lobby with fireplace, bookshelves, and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e98733dd-7961-4eac-b5c7-3524bc9e48e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-dcf7-7260-a3f0-d4626e97e458.webp",
      "image_media": {
        "alt_text": "A woman on the phone sits at a communal table in a lounge area with a laptop.",
        "public_id": "019e64a3-dcf7-7260-a3f0-d4626e97e458",
        "storage_key": "property/6767906449167324/019e64a3-dcf7-7260-a3f0-d4626e97e458.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Lifestyle",
      "description": "Work or relax in our resident lounge, featuring comfortable seating, a communal table with laptops, and a coffee bar area.",
      "link": "",
      "alt_text": "A woman on the phone sits at a communal table in a lounge area with a laptop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_935dd172-234c-4d40-b7d7-2c04f5c532c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-d3c5-74c3-9aca-2fbd0b6afd9f.webp",
      "image_media": {
        "alt_text": "Hallway with elevators, art, and a coffee station.",
        "public_id": "019e64a3-d3c5-74c3-9aca-2fbd0b6afd9f",
        "storage_key": "property/6767906449167324/019e64a3-d3c5-74c3-9aca-2fbd0b6afd9f.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Elegant hallway featuring modern art, accessible elevators, and a convenient coffee station for residents.",
      "link": "",
      "alt_text": "Hallway with elevators, art, and a coffee station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9d09f6fe-6c53-4978-8034-aae00f8c4f07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-d822-76d3-9b05-a33fe32ffc9a.webp",
      "image_media": {
        "alt_text": "The Majestic apartment building lobby with reception desk and staff.",
        "public_id": "019e64a3-d822-76d3-9b05-a33fe32ffc9a",
        "storage_key": "property/6767906449167324/019e64a3-d822-76d3-9b05-a33fe32ffc9a.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Welcome to The Majestic, featuring a sophisticated lobby with a modern reception desk and elegant decor. Our dedicated staff is ready to assist you.",
      "link": "",
      "alt_text": "The Majestic apartment building lobby with reception desk and staff.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_967d8749-2555-4186-a09b-984c4db23933",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-d9d5-73ee-ac03-17f361287a01.webp",
      "image_media": {
        "alt_text": "The Majestic apartment building lobby with a reception desk and two staff members.",
        "public_id": "019e64a3-d9d5-73ee-ac03-17f361287a01",
        "storage_key": "property/6767906449167324/019e64a3-d9d5-73ee-ac03-17f361287a01.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Welcome to The Majestic, where our modern and elegant lobby creates a lasting first impression. Our friendly staff is ready to assist you.",
      "link": "",
      "alt_text": "The Majestic apartment building lobby with a reception desk and two staff members.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4432d203-140e-42f6-b7f2-21fe0eb07dbf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-d6df-70b6-9e35-e086e1f27df8.webp",
      "image_media": {
        "alt_text": "Grand lobby with chandelier and seating area.",
        "public_id": "019e64a3-d6df-70b6-9e35-e086e1f27df8",
        "storage_key": "property/6767906449167324/019e64a3-d6df-70b6-9e35-e086e1f27df8.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Experience the elegant ambiance of our grand lobby, featuring a stunning chandelier, comfortable seating, and a welcoming reception area.",
      "link": "",
      "alt_text": "Grand lobby with chandelier and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e7a69f93-3515-4b8b-9ef4-c6a1408fffbf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-cdc6-7157-ad13-7c2c84d88f6b.webp",
      "image_media": {
        "alt_text": "Modern mailroom with brass mailboxes and a woman on the phone.",
        "public_id": "019e64a3-cdc6-7157-ad13-7c2c84d88f6b",
        "storage_key": "property/6767906449167324/019e64a3-cdc6-7157-ad13-7c2c84d88f6b.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Elegant mailroom featuring ample brass mailboxes and a contemporary marble-topped counter, providing residents with a sophisticated space.",
      "link": "",
      "alt_text": "Modern mailroom with brass mailboxes and a woman on the phone.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_87a9e6e6-9b74-44b1-b9ec-5832411c44cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-c1da-75ab-b4fe-17198c8665e1.webp",
      "image_media": {
        "alt_text": "Lobby with a fireplace and seating area.",
        "public_id": "019e64a3-c1da-75ab-b4fe-17198c8665e1",
        "storage_key": "property/6767906449167324/019e64a3-c1da-75ab-b4fe-17198c8665e1.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Step into a beautifully designed lobby, featuring a cozy fireplace and comfortable seating areas perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Lobby with a fireplace and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_60e652d4-0c13-4602-b339-93b651a11fff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-bf81-7650-9cd7-a675ba315964.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower-tub combo.",
        "public_id": "019e64a3-bf81-7650-9cd7-a675ba315964",
        "storage_key": "property/6767906449167324/019e64a3-bf81-7650-9cd7-a675ba315964.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Step into comfort with this beautifully designed bathroom, featuring a sleek vanity, modern toilet, and a relaxing shower-tub combination.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and shower-tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bb72c424-c6d2-4808-a307-63658fd7348a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-bda7-717e-95a8-5a2c027c5547.webp",
      "image_media": {
        "alt_text": "Lounge area with fireplace and seating.",
        "public_id": "019e64a3-bda7-717e-95a8-5a2c027c5547",
        "storage_key": "property/6767906449167324/019e64a3-bda7-717e-95a8-5a2c027c5547.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Relax and unwind in our elegant lounge area, complete with a cozy fireplace and comfortable seating.",
      "link": "",
      "alt_text": "Lounge area with fireplace and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7104a0ac-ecea-4b96-bfb3-9a8cf9e624d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-bda8-7616-bbf7-4655afbdbabc.webp",
      "image_media": {
        "alt_text": "Community lounge area with fireplace, bookshelves, and seating.",
        "public_id": "019e64a3-bda8-7616-bbf7-4655afbdbabc",
        "storage_key": "property/6767906449167324/019e64a3-bda8-7616-bbf7-4655afbdbabc.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Relax in our beautifully appointed community lounge, featuring a cozy fireplace, extensive bookshelves, and comfortable seating for socializing or quiet contemplation.",
      "link": "",
      "alt_text": "Community lounge area with fireplace, bookshelves, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8088df84-cb11-42a0-8daf-469cf2b8805c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-ba23-706d-8fee-1078b6b2b3fc.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, and bathtub with shower.",
        "public_id": "019e64a3-ba23-706d-8fee-1078b6b2b3fc",
        "storage_key": "property/6767906449167324/019e64a3-ba23-706d-8fee-1078b6b2b3fc.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Relax and unwind in our beautifully appointed bathrooms, featuring a modern vanity, sleek fixtures, and a spacious bathtub and shower combination.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bd8415e8-1878-4695-bbb0-c1f19e52390a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-bb02-74cf-8cd0-0ebc23656c2e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, marble countertops, and wooden cabinets.",
        "public_id": "019e64a3-bb02-74cf-8cd0-0ebc23656c2e",
        "storage_key": "property/6767906449167324/019e64a3-bb02-74cf-8cd0-0ebc23656c2e.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed kitchen featuring sleek stainless steel appliances, elegant marble countertops, and warm wooden cabinetry, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, marble countertops, and wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_798c797f-2cb0-4bf1-9037-69a177e8cd3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-ba26-75d9-9589-cc5c9a1add53.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a fireplace, seating, and a bar.",
        "public_id": "019e64a3-ba26-75d9-9589-cc5c9a1add53",
        "storage_key": "property/6767906449167324/019e64a3-ba26-75d9-9589-cc5c9a1add53.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring a cozy fireplace, comfortable seating, and a convenient bar area. Perfect for socializing or quiet relaxation.",
      "link": "",
      "alt_text": "Modern lounge area with a fireplace, seating, and a bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8240492a-0764-435b-a910-fd542d5a96ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-b9f8-741b-9f58-ed81bf2a4cc0.webp",
      "image_media": {
        "alt_text": "Interior coffee bar and lounge area with a painting and espresso machine.",
        "public_id": "019e64a3-b9f8-741b-9f58-ed81bf2a4cc0",
        "storage_key": "property/6767906449167324/019e64a3-b9f8-741b-9f58-ed81bf2a4cc0.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Enjoy fresh coffee from our stylish coffee bar, a perfect spot to relax or socialize within the community.",
      "link": "",
      "alt_text": "Interior coffee bar and lounge area with a painting and espresso machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_37016720-7ccc-440a-9ad0-9f65dce0cc0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-a877-774e-9dc6-c1672390beae.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a toilet, vanity, and shower.",
        "public_id": "019e64a3-a877-774e-9dc6-c1672390beae",
        "storage_key": "property/6767906449167324/019e64a3-a877-774e-9dc6-c1672390beae.webp",
        "width": 2823,
        "height": 2160
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this well-appointed bathroom, featuring a sleek vanity, modern toilet, and a clean, inviting shower space.",
      "link": "",
      "alt_text": "Modern bathroom with a toilet, vanity, and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3895355c-eaa9-4372-87a1-ad6ae8b6190a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-a377-75fa-989e-b6e2fc7e58d2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and bar stools",
        "public_id": "019e64a3-a377-75fa-989e-b6e2fc7e58d2",
        "storage_key": "property/6767906449167324/019e64a3-a377-75fa-989e-b6e2fc7e58d2.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "A stylish kitchen featuring stainless steel appliances, a marble backsplash, and a large island with bar seating.",
      "link": "",
      "alt_text": "Modern kitchen with island and bar stools",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ef56ca23-cad9-4982-b62d-06dc5b3f34ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-a0cb-7398-a11b-80d42f5d064a.webp",
      "image_media": {
        "alt_text": "The Majestic apartment building entrance with brick facade and arched windows.",
        "public_id": "019e64a3-a0cb-7398-a11b-80d42f5d064a",
        "storage_key": "property/6767906449167324/019e64a3-a0cb-7398-a11b-80d42f5d064a.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "The Majestic apartment building features a grand entrance with brick detailing, arched windows, and lush trees. Discover elegant living.",
      "link": "",
      "alt_text": "The Majestic apartment building entrance with brick facade and arched windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_731c9440-d17b-4ddb-8b80-e51ad15469ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-8ac5-7099-bb26-964bf932040f.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building facade with brick and white siding, balconies, and street-level retail.",
        "public_id": "019e64a3-8ac5-7099-bb26-964bf932040f",
        "storage_key": "property/6767906449167324/019e64a3-8ac5-7099-bb26-964bf932040f.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Discover urban living at its finest. This stunning apartment building features a beautiful blend of classic brick and modern siding, with spacious balconies and convenient street-level amenities.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building facade with brick and white siding, balconies, and street-level retail.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_42944b51-d819-4750-9206-410970459717",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-8375-749e-9dec-1c02de831f6a.webp",
      "image_media": {
        "alt_text": "Exterior rendering of a multi-story apartment building with balconies and arched ground floor entrances.",
        "public_id": "019e64a3-8375-749e-9dec-1c02de831f6a",
        "storage_key": "property/6767906449167324/019e64a3-8375-749e-9dec-1c02de831f6a.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "This is an exterior rendering of a modern apartment building. It features multiple floors with balconies, and the ground level has arched entrances and decorative stonework.",
      "link": "",
      "alt_text": "Exterior rendering of a multi-story apartment building with balconies and arched ground floor entrances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_48ee8d24-a605-4e4d-897f-1966f8518566",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-8dcb-742a-89c0-6441f78a90ed.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white toilet, vanity, and bathtub.",
        "public_id": "019e64a3-8dcb-742a-89c0-6441f78a90ed",
        "storage_key": "property/6767906449167324/019e64a3-8dcb-742a-89c0-6441f78a90ed.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "A stylish and modern bathroom featuring a clean white toilet, a wood-finished vanity with a marble countertop, and a deep soaking bathtub.",
      "link": "",
      "alt_text": "Modern bathroom with a white toilet, vanity, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cc930e3a-8331-4d0c-a06b-ca5d7902025c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-8485-773b-a41e-a987c37970e9.webp",
      "image_media": {
        "alt_text": "Exterior view of The Majestic apartment building with cars on the street.",
        "public_id": "019e64a3-8485-773b-a41e-a987c37970e9",
        "storage_key": "property/6767906449167324/019e64a3-8485-773b-a41e-a987c37970e9.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "The Majestic offers modern apartment living with stylish exteriors and convenient street access. Enjoy the vibrant community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of The Majestic apartment building with cars on the street.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_66655b37-b688-4e82-8a95-d036fee4d73e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-84dd-71fa-8822-ddf0473af3f8.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and trees.",
        "public_id": "019e64a3-84dd-71fa-8822-ddf0473af3f8",
        "storage_key": "property/6767906449167324/019e64a3-84dd-71fa-8822-ddf0473af3f8.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Captivating exterior view of our apartment building, showcasing its modern design, private balconies, and lush green surroundings.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with balconies and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c426c0f8-bb80-4c6c-bf2f-c47bc60a0434",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-848a-72ce-b9e0-eb878680be7e.webp",
      "image_media": {
        "alt_text": "Exterior of a large apartment building with balconies under a clear blue sky.",
        "public_id": "019e64a3-848a-72ce-b9e0-eb878680be7e",
        "storage_key": "property/6767906449167324/019e64a3-848a-72ce-b9e0-eb878680be7e.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "A rendering of the exterior of the apartment building, showcasing its architecture and design.",
      "link": "",
      "alt_text": "Exterior of a large apartment building with balconies under a clear blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_45174d7f-7adc-448d-a6e9-a2a84d9cb86a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-6cd3-7237-836f-3b3b1c77295b.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and arched windows.",
        "public_id": "019e64a3-6cd3-7237-836f-3b3b1c77295b",
        "storage_key": "property/6767906449167324/019e64a3-6cd3-7237-836f-3b3b1c77295b.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Discover modern living in this stunning apartment building, featuring elegant architecture and private balconies.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with balconies and arched windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8e0618eb-5728-4789-b01d-f9c6863e935d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-7150-74d8-8993-f63cf1042bfb.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily property at a street intersection with cars driving by.",
        "public_id": "019e64a3-7150-74d8-8993-f63cf1042bfb",
        "storage_key": "property/6767906449167324/019e64a3-7150-74d8-8993-f63cf1042bfb.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "A rendering of a modern multifamily building with balconies, located at a city street corner. This property offers convenient urban living.",
      "link": "",
      "alt_text": "Exterior view of a multifamily property at a street intersection with cars driving by.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dc2709e5-d902-4e68-b4fe-043fe96e42b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-7082-705b-9b85-f4936076d5fc.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and a central brick section.",
        "public_id": "019e64a3-7082-705b-9b85-f4936076d5fc",
        "storage_key": "property/6767906449167324/019e64a3-7082-705b-9b85-f4936076d5fc.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "This image showcases the exterior of a stylish apartment complex, highlighting its architectural details and balconies.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with balconies and a central brick section.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4cf79073-6784-40ad-ad51-3e975aaba840",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e64a3-6cce-711f-9bd1-5c6d7b334be4.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and a blue sky.",
        "public_id": "019e64a3-6cce-711f-9bd1-5c6d7b334be4",
        "storage_key": "property/6767906449167324/019e64a3-6cce-711f-9bd1-5c6d7b334be4.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Discover modern living in this stunning apartment building, featuring elegant architecture and private balconies for every resident. Experience comfort and style.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with balconies and a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a96457bb-2c24-41b4-827a-88fa32f885a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e3bea-41d8-722b-b275-d2ac9af9fc00.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and street.",
        "public_id": "019e3bea-41d8-722b-b275-d2ac9af9fc00",
        "storage_key": "property/6767906449167324/019e3bea-41d8-722b-b275-d2ac9af9fc00.webp",
        "width": 1920,
        "height": 702
      },
      "title": "Community",
      "description": "Discover sophisticated urban living in this beautifully designed apartment building, featuring stylish balconies and a prime location on a tree-lined street.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with balconies and street.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_ac2bef21-bd0f-4e97-87e7-42695f6c0a2f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "The Wild Huckleberry",
      "poi_type": "Restaurants",
      "poi_address": "302 S Mission St, Wenatchee, WA 98801, USA",
      "poi_short_description": "Charming eatery with American breakfast/lunch standards like pancakes and waffles, plus a boutique below.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-040b-71c6-ac63-f1049136060e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e4-040b-71c6-ac63-f1049136060e",
        "storage_key": "property/6767906449167324/019d45e4-040b-71c6-ac63-f1049136060e.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://wildhuck.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8174599953757204284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-wild-huckleberry",
      "poi_latitude": "47.4202537",
      "poi_longitude": "-120.3098738",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 509-663-1013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-071e-743f-98f6-1708e40063ed",
        "storage_key": "property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo6WVYerMm1QRPG-f2FgDcnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_16fb266b-e744-4377-a436-bd0448442c43",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Mela Coffee Roasting Co.",
      "poi_type": "Restaurants",
      "poi_address": "17 N Wenatchee Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "Relaxed, brick-walled option offering house-roasted java, cafe fare & baked goods.",
      "poi_long_description": "Relaxed, brick-walled option offering house-roasted java, cafe fare & baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-6fc3-7674-aa2d-776cf250674d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-6fc3-7674-aa2d-776cf250674d",
        "storage_key": "property/6767906449167324/019e1814-6fc3-7674-aa2d-776cf250674d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://melacoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10109752764219292441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mela-coffee-roasting-co",
      "poi_latitude": "47.4253006",
      "poi_longitude": "-120.3117218",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 509-888-0374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJazTIWJTMm1QRGXtQRpMOTYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_roastery"
    },
    {
      "id": "custom_e902fed1-ce13-4cb8-b1dc-12e370a5ccf9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Tastebuds",
      "poi_type": "Restaurants",
      "poi_address": "212 Fifth St A, Wenatchee, WA 98801, USA",
      "poi_short_description": "Dog-friendly, eatery offering salads, pizzas and more, along with coffee and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-6a96-7194-8a50-eb58f5ff689d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-6a96-7194-8a50-eb58f5ff689d",
        "storage_key": "property/6767906449167324/019e1814-6a96-7194-8a50-eb58f5ff689d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tastebudscoffeewine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9707087609912028091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tastebuds",
      "poi_latitude": "47.4302139",
      "poi_longitude": "-120.318222",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 509-888-2783",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-071e-743f-98f6-1708e40063ed",
        "storage_key": "property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh0NKd5fMm1QRu-tmOMCAtoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_01a37939-ae29-46a7-bd38-55f4f22b2b54",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "The Human Bean",
      "poi_type": "Restaurants",
      "poi_address": "35 S Mission St, Wenatchee, WA 98801, USA",
      "poi_short_description": "Drive-thru chain serving espresso, coffee, tea, smoothies & kid-friendly beverages.",
      "poi_long_description": "Drive-thru chain serving espresso, coffee, tea, smoothies & kid-friendly beverages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-69d8-71ee-a46e-a4dda2724d5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-69d8-71ee-a46e-a4dda2724d5f",
        "storage_key": "property/6767906449167324/019e1814-69d8-71ee-a46e-a4dda2724d5f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thehumanbean.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14376478322863330587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-human-bean",
      "poi_latitude": "47.4232982",
      "poi_longitude": "-120.3115773",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 509-888-3502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-b250-72d1-8fbf-b22678567f24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e5-b250-72d1-8fbf-b22678567f24",
        "storage_key": "property/6767906449167324/019d45e5-b250-72d1-8fbf-b22678567f24.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJtwZ8jS7Nm1QRG1VfY92Cg8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_691f8aa8-e6d2-4277-93d4-a5cba8fc74cd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Dutch Bros Coffee",
      "poi_type": "Restaurants",
      "poi_address": "739 S Mission St, Wenatchee, WA 98801, USA",
      "poi_short_description": "Fun-loving drive-thru serving up customized coffees, Rebel energy drinks, cold brew, tea & more.",
      "poi_long_description": "Fun-loving drive-thru serving up customized coffees, Rebel energy drinks, cold brew, tea & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-67e0-7469-8b26-9835a164738a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-67e0-7469-8b26-9835a164738a",
        "storage_key": "property/6767906449167324/019e1814-67e0-7469-8b26-9835a164738a.webp",
        "width": 959,
        "height": 1280
      },
      "poi_business_url": "https://www.dutchbros.com/locations/wa/wenatchee/739-s-mission-street?y_source=1_MTUyMjg0MDQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6349079679112753826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dutch-bros-coffee",
      "poi_latitude": "47.4136282",
      "poi_longitude": "-120.3043547",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 877-899-2767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-b250-72d1-8fbf-b22678567f24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e5-b250-72d1-8fbf-b22678567f24",
        "storage_key": "property/6767906449167324/019d45e5-b250-72d1-8fbf-b22678567f24.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJxRIDVd3Mm1QRorIqTFR2HFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_58199998-4824-4d90-a1e3-24616c27b627",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "La Fuente",
      "poi_type": "Restaurants",
      "poi_address": "816 S Mission St, Wenatchee, WA 98801, USA",
      "poi_short_description": "Family-friendly Mexican restaurant serving classic dishes & margaritas amid a homey vibe.",
      "poi_long_description": "Family-friendly Mexican restaurant serving classic dishes & margaritas amid a homey vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-ab9d-757c-aa95-d0ccf1204885.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e5-ab9d-757c-aa95-d0ccf1204885",
        "storage_key": "property/6767906449167324/019d45e5-ab9d-757c-aa95-d0ccf1204885.webp",
        "width": 2423,
        "height": 1201
      },
      "poi_business_url": "https://lafuentewenatchee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17959166685984240890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fuente",
      "poi_latitude": "47.4121657",
      "poi_longitude": "-120.3043509",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-664-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-071e-743f-98f6-1708e40063ed",
        "storage_key": "property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjaOZbN3Mm1QR-rQe_PLGO_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_be38282a-ec1f-4e1b-a02f-e23287bbf164",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "El Tapatio Mission St",
      "poi_type": "Restaurants",
      "poi_address": "509 S Mission St, Wenatchee, WA 98801, USA",
      "poi_short_description": "Casual taco truck serving tacos, burritos and other Mexican comfort foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-68c4-72b4-8b04-79f581b6eac6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-68c4-72b4-8b04-79f581b6eac6",
        "storage_key": "property/6767906449167324/019e1814-68c4-72b4-8b04-79f581b6eac6.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17855632335288140543&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-tapatio-mission-st",
      "poi_latitude": "47.41789319999999",
      "poi_longitude": "-120.3073368",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 509-433-9696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-071e-743f-98f6-1708e40063ed",
        "storage_key": "property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg-Rd8unMm1QR_wLUeAHzy_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b8d91895-a62d-41d2-8247-96f6e04da8f3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Iwa Sushi and Grill",
      "poi_type": "Restaurants",
      "poi_address": "8 N Wenatchee Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "Relaxed, brick-lined space with a sushi bar for inventive maki, Japanese kitchen entrees & sake.",
      "poi_long_description": "Relaxed, brick-lined space with a sushi bar for inventive maki, Japanese kitchen entrees & sake.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-b734-75da-a871-9e79ec579d06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e5-b734-75da-a871-9e79ec579d06",
        "storage_key": "property/6767906449167324/019d45e5-b734-75da-a871-9e79ec579d06.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://order.mealkeyway.com/merchant/4d52713055306d514f6a4e30436c30434b67737254673d3d/main",
      "poi_directions_map_url": "https://maps.google.com/?cid=9560344551990744119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iwa-sushi-and-grill",
      "poi_latitude": "47.4248777",
      "poi_longitude": "-120.312031",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 509-667-8744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-071e-743f-98f6-1708e40063ed",
        "storage_key": "property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuQa5-ZTMm1QRN9S_l7cqrYQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_c3f6711c-c09a-453f-9ee7-e0733903b073",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Mission Burgers & Chicken",
      "poi_type": "Restaurants",
      "poi_address": "900 S Wenatchee Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "Burger joint that also serves chicken sandwiches, veggie burgers, fries and milkshakes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d4e9b-863e-77e9-9564-b29c75073ffb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d4e9b-863e-77e9-9564-b29c75073ffb",
        "storage_key": "property/6767906449167324/019d4e9b-863e-77e9-9564-b29c75073ffb.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://mission-burger.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9837383882442816046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-burgers--chicken",
      "poi_latitude": "47.4127981",
      "poi_longitude": "-120.3022161",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-665-3622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-071e-743f-98f6-1708e40063ed",
        "storage_key": "property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ciU4erNm1QRLjooOIVohYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_44bc0d99-9de9-495f-bd20-8415ddbac2d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Sweetwood BBQ",
      "poi_type": "Restaurants",
      "poi_address": "905 N Wenatchee Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "Unfussy strip-mall eatery offering BBQ sandwiches & plates plus sides & happy hour specials.",
      "poi_long_description": "Unfussy strip-mall eatery offering BBQ sandwiches & plates plus sides & happy hour specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-c9f9-74cd-a8b8-c4db2d8414b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e5-c9f9-74cd-a8b8-c4db2d8414b9",
        "storage_key": "property/6767906449167324/019d45e5-c9f9-74cd-a8b8-c4db2d8414b9.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.wenatcheebbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=341432327313291014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweetwood-bbq",
      "poi_latitude": "47.4358351",
      "poi_longitude": "-120.3190892",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 509-888-4557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-071e-743f-98f6-1708e40063ed",
        "storage_key": "property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI3B28pvMm1QRBvdXiOQCvQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c868a1f8-4580-42fe-b884-6afedd29a36e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "South at Pybus",
      "poi_type": "Restaurants",
      "poi_address": "7 N Worthen St E15, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-b97d-70c8-90ce-a146d776c3e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e5-b97d-70c8-90ce-a146d776c3e1",
        "storage_key": "property/6767906449167324/019d45e5-b97d-70c8-90ce-a146d776c3e1.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.southrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12760848192344910104&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-at-pybus",
      "poi_latitude": "47.4254934",
      "poi_longitude": "-120.3075337",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-888-5463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-071e-743f-98f6-1708e40063ed",
        "storage_key": "property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0z1WbpPMm1QRGGlnMdKjF7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_9e422dbc-bf67-42f8-877f-9086226e13c9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "The Taproom by Hellbent Brewing",
      "poi_type": "Restaurants",
      "poi_address": "7 N Worthen St W8, Wenatchee, WA 98801, USA",
      "poi_short_description": "Located in Pybus Market, this family-friendly destination offers Hellbent brews, ciders, cocktails, and pub grub.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-6a3e-75f4-9bab-f29adcc48c73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-6a3e-75f4-9bab-f29adcc48c73",
        "storage_key": "property/6767906449167324/019e1814-6a3e-75f4-9bab-f29adcc48c73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://taproomby.hellbentbrewingcompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12616972063818596384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-taproom-by-hellbent-brewing",
      "poi_latitude": "47.4252961",
      "poi_longitude": "-120.3074744",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-901-4569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-071e-743f-98f6-1708e40063ed",
        "storage_key": "property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrTw1iSTNm1QRIEDvlD59GK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_cf6e7e70-4d2e-4b22-9e3a-cf852b36329e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "The Huck at Pybus",
      "poi_type": "Restaurants",
      "poi_address": "7 N Worthen St, Wenatchee, WA 98801, USA",
      "poi_short_description": "Relaxed restaurant in the Pybus Public Market offering burgers, cocktails, and breakfast options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-6f5e-716c-af6b-9e04da830893.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-6f5e-716c-af6b-9e04da830893",
        "storage_key": "property/6767906449167324/019e1814-6f5e-716c-af6b-9e04da830893.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://wildhuck.com/the-huck-pybus",
      "poi_directions_map_url": "https://maps.google.com/?cid=5130618458456785193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-huck-at-pybus",
      "poi_latitude": "47.4251637",
      "poi_longitude": "-120.3070947",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-888-0303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-071e-743f-98f6-1708e40063ed",
        "storage_key": "property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVRNNKXzNm1QRKQFhBk6eM0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_be52fcef-fb68-40cb-8412-0c9cae5cb68d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "King Pizza",
      "poi_type": "Restaurants",
      "poi_address": "30 S Wenatchee Ave #2B, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-6f7a-773f-af17-2f02ba7670a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-6f7a-773f-af17-2f02ba7670a6",
        "storage_key": "property/6767906449167324/019e1814-6f7a-773f-af17-2f02ba7670a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/profile.php?id=61554352258295",
      "poi_directions_map_url": "https://maps.google.com/?cid=3841017211538117798&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-pizza",
      "poi_latitude": "47.4234898",
      "poi_longitude": "-120.3110442",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 509-888-5115",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-071e-743f-98f6-1708e40063ed",
        "storage_key": "property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp4Kab1_Nm1QRphTkpc0ITjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_5d391116-d851-48fc-aed4-4a6bdd59dc99",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Visconti's Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1737 N Wenatchee Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "Italian classics, wood-fired pizzas & a broad wine list served in a traditional atmosphere.",
      "poi_long_description": "Italian classics, wood-fired pizzas & a broad wine list served in a traditional atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d4e9b-97cc-70ef-b222-902ea90e9353.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d4e9b-97cc-70ef-b222-902ea90e9353",
        "storage_key": "property/6767906449167324/019d4e9b-97cc-70ef-b222-902ea90e9353.webp",
        "width": 1280,
        "height": 1920
      },
      "poi_business_url": "https://viscontis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=675421452683802901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "viscontis-italian-restaurant",
      "poi_latitude": "47.4493304",
      "poi_longitude": "-120.3311341",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 509-662-5013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-071e-743f-98f6-1708e40063ed",
        "storage_key": "property/6767906449167324/019d45e4-071e-743f-98f6-1708e40063ed.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMz5lh2_Lm1QRFXnlkDuUXwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_0ac9c6f3-885d-496c-aeba-d5fb3918db73",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "925 S Mission St, Wenatchee, WA 98801, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-d89d-7638-bcf1-64ce0056da6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e5-d89d-7638-bcf1-64ce0056da6d",
        "storage_key": "property/6767906449167324/019d45e5-d89d-7638-bcf1-64ce0056da6d.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.7-eleven.com/locations/wa/wenatchee/925-s-mission-20804?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=14636161654443700492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "47.4106033",
      "poi_longitude": "-120.3027745",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 509-662-1044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-e334-7037-8b65-a1800d8b11db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e5-e334-7037-8b65-a1800d8b11db",
        "storage_key": "property/6767906449167324/019d45e5-e334-7037-8b65-a1800d8b11db.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ39Wvvt3Mm1QRDHFPoHoXHss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_74b3fff7-df6f-4f06-9f6c-2dcc4645e4e6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "501 N Miller St, Wenatchee, WA 98801, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-1335-7719-bd8f-3486a67f4ea6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e4-1335-7719-bd8f-3486a67f4ea6",
        "storage_key": "property/6767906449167324/019d45e4-1335-7719-bd8f-3486a67f4ea6.webp",
        "width": 552,
        "height": 310
      },
      "poi_business_url": "https://local.safeway.com/safeway/wa/wenatchee/501-n-miller-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14663735238698594359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "47.4310909",
      "poi_longitude": "-120.3240427",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 509-663-5336",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-14a7-7211-9139-11043e42d86e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-14a7-7211-9139-11043e42d86e",
        "storage_key": "property/6767906449167324/019d45e4-14a7-7211-9139-11043e42d86e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKT1WoaLMm1QRN_AB_4ENgMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c18c999a-70aa-4193-bf94-d8e913dfca01",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Grocery Outlet",
      "poi_type": "Shopping & Retail",
      "poi_address": "1616 N Wenatchee Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "Discount chain carrying brand-name groceries, plus items like gifts & toys (many sell beer & wine).",
      "poi_long_description": "Discount chain carrying brand-name groceries, plus items like gifts & toys (many sell beer & wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-e769-76fc-b908-2c8f8a564928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e5-e769-76fc-b908-2c8f8a564928",
        "storage_key": "property/6767906449167324/019d45e5-e769-76fc-b908-2c8f8a564928.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://www.groceryoutlet.com/circulars/storeid/77",
      "poi_directions_map_url": "https://maps.google.com/?cid=6526806456765096080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grocery-outlet",
      "poi_latitude": "47.4468025",
      "poi_longitude": "-120.3303726",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 509-663-4477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-14a7-7211-9139-11043e42d86e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-14a7-7211-9139-11043e42d86e",
        "storage_key": "property/6767906449167324/019d45e4-14a7-7211-9139-11043e42d86e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95UkVWTLm1QRkKA1VeTfk1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a405f4c3-1557-48a0-acf2-fbb4a4477f68",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "1340 N Wenatchee Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "Discount grocery store featuring bulk foods, sushi and a deli.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1812-370e-74da-acbd-e80b3c82b248.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1812-370e-74da-acbd-e80b3c82b248",
        "storage_key": "property/6767906449167324/019e1812-370e-74da-acbd-e80b3c82b248.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6893139599968523678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "47.4417707",
      "poi_longitude": "-120.3282025",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 509-317-7907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-14a7-7211-9139-11043e42d86e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-14a7-7211-9139-11043e42d86e",
        "storage_key": "property/6767906449167324/019d45e4-14a7-7211-9139-11043e42d86e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSxNdBvLm1QRnlVN2_FZqV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_bb78c1f8-eb95-4c34-a4fb-46ff6deefba2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1050 N Miller St, Wenatchee, WA 98801, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-d8c4-745c-a53d-0d38e031a393.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e5-d8c4-745c-a53d-0d38e031a393",
        "storage_key": "property/6767906449167324/019d45e5-d8c4-745c-a53d-0d38e031a393.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1050+n+miller+st-wenatchee-wa-98801/id=2670",
      "poi_directions_map_url": "https://maps.google.com/?cid=10940512148173631241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "47.4363646",
      "poi_longitude": "-120.3256881",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 509-665-7539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDymt557Mm1QRCS-8XNWB1Jc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_f92bf5d0-a06d-4a4b-bd73-9cceeaa6528f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Pybus Public Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3 N Worthen St, Wenatchee, WA 98801, USA",
      "poi_short_description": "Open, airy marketplace featuring local farm goods, artisanal foods, restaurants & specialty shops.",
      "poi_long_description": "Open, airy marketplace featuring local farm goods, artisanal foods, restaurants & specialty shops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-74c3-716e-b74b-823a359420e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-74c3-716e-b74b-823a359420e9",
        "storage_key": "property/6767906449167324/019e1814-74c3-716e-b74b-823a359420e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pybuspublicmarket.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7101377044305703352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pybus-public-market",
      "poi_latitude": "47.4252672",
      "poi_longitude": "-120.30733",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-888-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-145c-71db-baf8-4ea3367166a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-145c-71db-baf8-4ea3367166a8",
        "storage_key": "property/6767906449167324/019d45e4-145c-71db-baf8-4ea3367166a8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz0r-Z5PMm1QRuHH0DcwojWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_5fcfb319-50f8-4591-9591-52d1a5c85ba8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2000 N Wenatchee Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "Large chain selling groceries and home goods (clothing, toys).",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d4e9b-d061-75b9-9474-5402e698a070.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d4e9b-d061-75b9-9474-5402e698a070",
        "storage_key": "property/6767906449167324/019d4e9b-d061-75b9-9474-5402e698a070.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2187-wenatchee-wa/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11769022329653084427&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "47.454271",
      "poi_longitude": "-120.3392165",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 509-664-2448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-145c-71db-baf8-4ea3367166a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-145c-71db-baf8-4ea3367166a8",
        "storage_key": "property/6767906449167324/019d45e4-145c-71db-baf8-4ea3367166a8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlUkn323Lm1QRC8GcMHT3U6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_642650c2-04bc-432c-a38e-e4b594033af3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "375 Highline Dr, East Wenatchee, WA 98802, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-e615-768f-9a19-87a20952bb6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e5-e615-768f-9a19-87a20952bb6c",
        "storage_key": "property/6767906449167324/019d45e5-e615-768f-9a19-87a20952bb6c.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/east-wenatchee-WA-112.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=11768804474436663832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "47.4013868",
      "poi_longitude": "-120.279693",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 509-886-0593",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-145c-71db-baf8-4ea3367166a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-145c-71db-baf8-4ea3367166a8",
        "storage_key": "property/6767906449167324/019d45e4-145c-71db-baf8-4ea3367166a8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa9l4LBrNm1QRGDrT0VAxU6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_8450cc55-7520-4d10-92e7-82dbb0cb0cf0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "11 Grant Rd, East Wenatchee, WA 98802, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-128d-71b0-b63f-e43502d4de79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e4-128d-71b0-b63f-e43502d4de79",
        "storage_key": "property/6767906449167324/019d45e4-128d-71b0-b63f-e43502d4de79.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/wa/east-wenatchee/wenatchee/701/00654?cid=loc_70100654_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=7549072793411911709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "47.4067005",
      "poi_longitude": "-120.2909294",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 509-881-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-14a7-7211-9139-11043e42d86e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-14a7-7211-9139-11043e42d86e",
        "storage_key": "property/6767906449167324/019d45e4-14a7-7211-9139-11043e42d86e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw3CJ0-HMm1QRHQDierWxw2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6c2c590a-67bd-41b3-a5e2-4c5227e4e791",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Wenatchee Valley Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "511 Valley Mall Pkwy, East Wenatchee, WA 98802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-e667-756e-af8d-d3acd5fefca9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e5-e667-756e-af8d-d3acd5fefca9",
        "storage_key": "property/6767906449167324/019d45e5-e667-756e-af8d-d3acd5fefca9.webp",
        "width": 3072,
        "height": 2313
      },
      "poi_business_url": "http://www.wenatcheevalleymall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9695366368937644389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wenatchee-valley-mall",
      "poi_latitude": "47.4114467",
      "poi_longitude": "-120.2892811",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 509-884-6645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-145c-71db-baf8-4ea3367166a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-145c-71db-baf8-4ea3367166a8",
        "storage_key": "property/6767906449167324/019d45e4-145c-71db-baf8-4ea3367166a8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJVa-l-PMm1QRZRHMI1jcjIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b13d75db-59ac-4b4b-a554-fbc7335976e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Washington Elementary School",
      "poi_type": "Education",
      "poi_address": "1401 Washington St, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-fcfe-75ca-8f4e-b6cd75411e78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e5-fcfe-75ca-8f4e-b6cd75411e78",
        "storage_key": "property/6767906449167324/019d45e5-fcfe-75ca-8f4e-b6cd75411e78.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.wenatcheeschools.org/wa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17576364865435492377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-elementary-school",
      "poi_latitude": "47.4213894",
      "poi_longitude": "-120.3362828",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 509-662-5504",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-22c8-77ce-bd03-6a482861ced6",
        "storage_key": "property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKwtEIbHMm1QRGWDwtrjK6_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b94e6f66-7aab-462e-a053-db695fce2a53",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Mission View Elementary School",
      "poi_type": "Education",
      "poi_address": "60 Terminal Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.wenatcheeschools.org/mv/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9567658449285881798&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-view-elementary-school",
      "poi_latitude": "47.3987002",
      "poi_longitude": "-120.2993063",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 509-663-5851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-22c8-77ce-bd03-6a482861ced6",
        "storage_key": "property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoYVfLSTNm1QRxh_zAasmx4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_0fcb5336-11f0-4533-9bb6-6165bb64562b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "John Newbery Elementary School",
      "poi_type": "Education",
      "poi_address": "850 N Western Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wenatcheeschools.org/nb",
      "poi_directions_map_url": "https://maps.google.com/?cid=7126629037528138448&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-newbery-elementary-school",
      "poi_latitude": "47.4328289",
      "poi_longitude": "-120.3475605",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 509-664-8930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-22c8-77ce-bd03-6a482861ced6",
        "storage_key": "property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAYuhMKjMm1QR0ELZ41nf5mI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_376a0f45-f086-4de8-8470-f008f5840010",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Lewis & Clark Elementary School",
      "poi_type": "Education",
      "poi_address": "1130 Princeton Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.wenatcheeschools.org/lc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11468417557422864990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewis--clark-elementary-school",
      "poi_latitude": "47.43757799999999",
      "poi_longitude": "-120.3303851",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 509-663-5351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-22c8-77ce-bd03-6a482861ced6",
        "storage_key": "property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIZWfwZ_Mm1QRXvoKlgEBKJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_8e44d533-77df-4aba-8f99-abdae87a4a23",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Lincoln Elementary School",
      "poi_type": "Education",
      "poi_address": "1224 Methow St, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.wenatcheeschools.org/lin/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5047884328387870479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lincoln-elementary-school",
      "poi_latitude": "47.406823",
      "poi_longitude": "-120.309608",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 509-663-5710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-22c8-77ce-bd03-6a482861ced6",
        "storage_key": "property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEwcQgNnMm1QRD__RRA2wDUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f6bbc77a-e2c0-4a77-ae2e-46fcb6aa5e3b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Orchard Middle School",
      "poi_type": "Education",
      "poi_address": "1024 Orchard Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d4e9b-de6e-718f-9dce-7f83ee18132a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d4e9b-de6e-718f-9dce-7f83ee18132a",
        "storage_key": "property/6767906449167324/019d4e9b-de6e-718f-9dce-7f83ee18132a.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.wenatcheeschools.org/oms/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16378747250303662470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orchard-middle-school",
      "poi_latitude": "47.42681839999999",
      "poi_longitude": "-120.3265413",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 509-662-7745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-22c8-77ce-bd03-6a482861ced6",
        "storage_key": "property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE2YSs7rMm1QRhnlBiNj_TOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e500943d-d590-457c-9107-9d0fe03a355b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Foothills Middle School",
      "poi_type": "Education",
      "poi_address": "1410 Maple St, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-f3ab-716f-b0fd-e4ad7f323d5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e5-f3ab-716f-b0fd-e4ad7f323d5e",
        "storage_key": "property/6767906449167324/019d45e5-f3ab-716f-b0fd-e4ad7f323d5e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.wenatcheeschools.org/fms/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12880229641021435937&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foothills-middle-school",
      "poi_latitude": "47.4431293",
      "poi_longitude": "-120.3360185",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 509-664-8961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-22c8-77ce-bd03-6a482861ced6",
        "storage_key": "property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ54qMy2DLm1QRITCKup3Ev7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6eba00a5-7562-449e-b28a-764c45b22e7a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Wenatchee High School",
      "poi_type": "Education",
      "poi_address": "1101 Millerdale Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-f471-743e-ab42-3048eb815019.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e5-f471-743e-ab42-3048eb815019",
        "storage_key": "property/6767906449167324/019d45e5-f471-743e-ab42-3048eb815019.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.wenatcheeschools.org/whs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16285405705792675576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wenatchee-high-school",
      "poi_latitude": "47.4104906",
      "poi_longitude": "-120.326511",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 509-663-8117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-22c8-77ce-bd03-6a482861ced6",
        "storage_key": "property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa_2EWsfMm1QR-F7kpDRiAeI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f9b6328d-66aa-4b27-a340-4fbf32eb568e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Wenatchee Valley College",
      "poi_type": "Education",
      "poi_address": "1300 Fifth St, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-1f2b-7290-a1ed-ce5f938f7a79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e4-1f2b-7290-a1ed-ce5f938f7a79",
        "storage_key": "property/6767906449167324/019d45e4-1f2b-7290-a1ed-ce5f938f7a79.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "http://www.wvc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16282717938722520972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wenatchee-valley-college",
      "poi_latitude": "47.4305083",
      "poi_longitude": "-120.3355336",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 509-682-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-22c8-77ce-bd03-6a482861ced6",
        "storage_key": "property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUXDhIaTMm1QRjL9vG7LV9-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_caed0b38-c8d3-45ad-8cd3-1080c48890a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "TEAMS Learning Center",
      "poi_type": "Education",
      "poi_address": "317 First St, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-fe2b-7433-baca-06c2ee6586e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e5-fe2b-7433-baca-06c2ee6586e3",
        "storage_key": "property/6767906449167324/019d45e5-fe2b-7433-baca-06c2ee6586e3.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.teamslearningcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10081705238487121308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "teams-learning-center",
      "poi_latitude": "47.4245688",
      "poi_longitude": "-120.3161786",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 509-860-5241",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-22c8-77ce-bd03-6a482861ced6",
        "storage_key": "property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJleTzlpXMm1QRnD04zn9p6Ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_4425b157-58b7-4e75-94a8-1cea80ccd7e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Wenatchee Valley Museum & Cultural Center",
      "poi_type": "Entertainment",
      "poi_address": "Annex Building, 127 S Mission St, Wenatchee, WA 98801, USA",
      "poi_short_description": "Local exhibits on history, arts, and sciences, including an annual haunted museum.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-1e61-76da-a1bf-77e2b4e4f9a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e4-1e61-76da-a1bf-77e2b4e4f9a0",
        "storage_key": "property/6767906449167324/019d45e4-1e61-76da-a1bf-77e2b4e4f9a0.webp",
        "width": 2048,
        "height": 1536
      },
      "poi_business_url": "http://www.wenatcheevalleymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1080653927365038824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wenatchee-valley-museum--cultural-center",
      "poi_latitude": "47.4224411",
      "poi_longitude": "-120.3108731",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 509-888-6240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-24a8-72b8-9064-de6a8df5ebfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-24a8-72b8-9064-de6a8df5ebfe",
        "storage_key": "property/6767906449167324/019d45e4-24a8-72b8-9064-de6a8df5ebfe.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJS9h4zurMm1QR6FK5eQVB_w4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a3b33ceb-b51f-4250-9946-e81155236cde",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Numerica Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "123 N Wenatchee Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "Venue for musicals, plays, ballets, live music and other forms of theatrical entertainment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-0aea-7734-8e82-52f4dd4118a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e6-0aea-7734-8e82-52f4dd4118a3",
        "storage_key": "property/6767906449167324/019d45e6-0aea-7734-8e82-52f4dd4118a3.webp",
        "width": 2048,
        "height": 1365
      },
      "poi_business_url": "http://www.numericapac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14949215327317143620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "numerica-performing-arts-center",
      "poi_latitude": "47.4267148",
      "poi_longitude": "-120.3126628",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 509-663-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz7ukPpTMm1QRRDCQxyJIds8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_751130b2-24b0-4f81-ab57-91e9c24b2c5a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Town Toyota Center",
      "poi_type": "Entertainment",
      "poi_address": "1300 Walla Walla Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "Clean-looking venue featuring concerts, hockey games and an ice rink.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-204d-768d-ae65-7a9e65af1df9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e4-204d-768d-ae65-7a9e65af1df9",
        "storage_key": "property/6767906449167324/019d45e4-204d-768d-ae65-7a9e65af1df9.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://towntoyotacenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15681597571316275905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-toyota-center",
      "poi_latitude": "47.4426081",
      "poi_longitude": "-120.3219559",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 509-667-7847",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjfnLv2LLm1QRwVrvDOg5oNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_cb044206-e0bb-4ac5-89d8-702e1bb200b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Gateway Cinema",
      "poi_type": "Entertainment",
      "poi_address": "151 Easy Way #8109, Wenatchee, WA 98801, USA",
      "poi_short_description": "Locally owned cineplex with 9 screens, including an adults-only luxury theater with bar.",
      "poi_long_description": "Locally owned cineplex with 9 screens, including an adults-only luxury theater with bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-0c3c-774c-86a5-d879387b1209.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e6-0c3c-774c-86a5-d879387b1209",
        "storage_key": "property/6767906449167324/019d45e6-0c3c-774c-86a5-d879387b1209.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3852439949148829760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gateway-cinema",
      "poi_latitude": "47.4683307",
      "poi_longitude": "-120.3312406",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 509-662-4567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-1542-741b-a9f4-6821b7e1b94c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e6-1542-741b-a9f4-6821b7e1b94c",
        "storage_key": "property/6767906449167324/019d45e6-1542-741b-a9f4-6821b7e1b94c.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJqzUS5gfLm1QRQDiK_7iddjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_b8ff7faf-dd6f-44e4-b26f-9e5ce341baa6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Ohme Gardens",
      "poi_type": "Entertainment",
      "poi_address": "3327 Ohme Rd, Wenatchee, WA 98801, USA",
      "poi_short_description": "A mile of natural stone paths amid hillside gardens, pools & woods. Open seasonally.",
      "poi_long_description": "A mile of natural stone paths amid hillside gardens, pools & woods. Open seasonally.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-18d2-71ce-a339-f3ba0bfcd0b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e6-18d2-71ce-a339-f3ba0bfcd0b4",
        "storage_key": "property/6767906449167324/019d45e6-18d2-71ce-a339-f3ba0bfcd0b4.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://ohmegardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=450430188320322944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ohme-gardens",
      "poi_latitude": "47.47801070000001",
      "poi_longitude": "-120.326297",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 509-662-5785",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU0BR5K3Lm1QRgPXxqt4_QAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_eed91293-4392-48df-897a-4c246899eb5d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Columbia Valley Brewing",
      "poi_type": "Entertainment",
      "poi_address": "538 Riverside Dr, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-cc71-755f-851c-2ffd04005f5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e5-cc71-755f-851c-2ffd04005f5c",
        "storage_key": "property/6767906449167324/019d45e5-cc71-755f-851c-2ffd04005f5c.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://m.facebook.com/Columbia-Valley-Brewing-378730758863150/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13467071377423978866&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-valley-brewing",
      "poi_latitude": "47.4329009",
      "poi_longitude": "-120.3136516",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-888-9993",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa3RwfCy1m1QRctEv8BCm5Lo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_f0d02171-4fad-41a0-98b7-1188ad718e07",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Wenatchee Valley Brewing Co.",
      "poi_type": "Entertainment",
      "poi_address": "108 E Island View St, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e5-caa2-7265-8ced-b52dbc7989cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e5-caa2-7265-8ced-b52dbc7989cc",
        "storage_key": "property/6767906449167324/019d45e5-caa2-7265-8ced-b52dbc7989cc.webp",
        "width": 2144,
        "height": 1424
      },
      "poi_business_url": "http://wenatcheevalleybrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1106203540041500220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wenatchee-valley-brewing-co",
      "poi_latitude": "47.4349313",
      "poi_longitude": "-120.3147259",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 509-881-4529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0LaZ5PMm1QRPAZ0PUIGWg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_6d0f92ce-1988-4d99-b342-ee3176df1656",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Centennial Park",
      "poi_type": "Entertainment",
      "poi_address": "130 S Wenatchee Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d4e9c-0996-727b-a049-9408f8879c0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d4e9c-0996-727b-a049-9408f8879c0d",
        "storage_key": "property/6767906449167324/019d4e9c-0996-727b-a049-9408f8879c0d.webp",
        "width": 3072,
        "height": 2313
      },
      "poi_business_url": "http://centennial-park-wenatchee.jany.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17260963456686509652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centennial-park",
      "poi_latitude": "47.4222978",
      "poi_longitude": "-120.3099503",
      "poi_miles_from_property": "0.07",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 509-888-3284",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-656b-719d-b623-8f1d55b4efc7",
        "storage_key": "property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJua7A2erMm1QRVE7MtM9Ci-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_30ce9fc5-446a-44b3-b911-bf79e78dfe21",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Confluence Health | Wenatchee Valley Hospital & Clinics: Jerry Baldwin, PA-C",
      "poi_type": "Health and Wellness",
      "poi_address": "820 N Chelan Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-7974-74ff-aaa5-39840c39bb7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-7974-74ff-aaa5-39840c39bb7d",
        "storage_key": "property/6767906449167324/019e1814-7974-74ff-aaa5-39840c39bb7d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.confluencehealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16250670530629748624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "confluence-health--wenatchee-valley-hospital--clinics-jerry-baldwin-pa-c",
      "poi_latitude": "47.4337425",
      "poi_longitude": "-120.3231124",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 509-665-5888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxfGD4ZjMm1QRkEcYdL_6heE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_1d2a0f8a-3927-4743-9de7-4a6639462190",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Columbia Valley Community Health Center",
      "poi_type": "Health and Wellness",
      "poi_address": "600 Orondo Ave STE 1, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-260e-71f8-aa8f-c3f64e81339c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e6-260e-71f8-aa8f-c3f64e81339c",
        "storage_key": "property/6767906449167324/019d45e6-260e-71f8-aa8f-c3f64e81339c.webp",
        "width": 2592,
        "height": 1080
      },
      "poi_business_url": "http://cvch.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3038948199022317327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-valley-community-health-center",
      "poi_latitude": "47.4190865",
      "poi_longitude": "-120.3177285",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-662-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7y_ozsDMm1QRD8-JNUmDLCo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_d68de479-82e8-4bda-b96e-4ce5f5a9e2ec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Wenatchee Clinic Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "820 N Chelan Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.clinic-rx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9502447066060292559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wenatchee-clinic-pharmacy",
      "poi_latitude": "47.433828",
      "poi_longitude": "-120.323306",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 509-662-5801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-2504-700f-a24c-88bd5f533281.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e6-2504-700f-a24c-88bd5f533281",
        "storage_key": "property/6767906449167324/019d45e6-2504-700f-a24c-88bd5f533281.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8e5G4JjMm1QRzwF6rUJ534M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_27b0f6d4-f1c9-44b7-ae25-4345e19aef60",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Safeway Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "501 N Miller St, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-789a-768f-93ff-ec4787394aca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-789a-768f-93ff-ec4787394aca",
        "storage_key": "property/6767906449167324/019e1814-789a-768f-93ff-ec4787394aca.webp",
        "width": 554,
        "height": 311
      },
      "poi_business_url": "https://local.pharmacy.safeway.com/safeway/wa/wenatchee/501-n-miller-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=799119697416161050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway-pharmacy",
      "poi_latitude": "47.4309253",
      "poi_longitude": "-120.3241018",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 509-663-5575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-2504-700f-a24c-88bd5f533281.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e6-2504-700f-a24c-88bd5f533281",
        "storage_key": "property/6767906449167324/019d45e6-2504-700f-a24c-88bd5f533281.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKT1WoaLMm1QRGgeCgSELFws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_7c8d5f9c-4104-47a9-9eaf-0d7c90d5762b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "149 Easy Way, Wenatchee, WA 98801, USA",
      "poi_short_description": "Chain fitness center with tanning beds offering 24-hour access.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2ef9-70f5-90ec-29c76d0faaff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e4-2ef9-70f5-90ec-29c76d0faaff",
        "storage_key": "property/6767906449167324/019d45e4-2ef9-70f5-90ec-29c76d0faaff.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/wenatchee-wa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16604147919127176057&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "47.46794",
      "poi_longitude": "-120.33285",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 509-888-7306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRd8mvpPLm1QReeOdVY_IbeY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_375d7132-5b2c-48a9-abb2-5e7fcfb6692d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "950 N Wenatchee Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "Small fitness center featuring 24-hour access, plus personal training and tanning beds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-4311-7640-8bf6-03e3498ed064.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e4-4311-7640-8bf6-03e3498ed064",
        "storage_key": "property/6767906449167324/019d45e4-4311-7640-8bf6-03e3498ed064.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/wenatchee-washington-2962/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=2962",
      "poi_directions_map_url": "https://maps.google.com/?cid=7637154518430596270&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "47.4361731",
      "poi_longitude": "-120.3212749",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 509-888-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ88nXAZzMm1QRrjzTNZKf_Gk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_15448ba8-f612-4411-8b65-cfdd1fdec8ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "CrossFit Covey",
      "poi_type": "Health and Wellness",
      "poi_address": "151 Easy Way #100, Wenatchee, WA 98801, USA",
      "poi_short_description": "Clean health club featuring training for all levels as well as open gym area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-305f-751e-9e16-3a5fb7bd975e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e6-305f-751e-9e16-3a5fb7bd975e",
        "storage_key": "property/6767906449167324/019d45e6-305f-751e-9e16-3a5fb7bd975e.webp",
        "width": 1536,
        "height": 2048
      },
      "poi_business_url": "http://cfcovey.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18372623558414670131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-covey",
      "poi_latitude": "47.4683074",
      "poi_longitude": "-120.3321255",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 509-661-3997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV4GALrHLm1QRM5lHt8ir-P4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_16e41321-5ae2-4aac-82b4-9bb0259d34e7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "LEAF GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "525 N Piere St, Wenatchee, WA 98801, USA",
      "poi_short_description": "Group fitness gym and physical training studio with helpful staff, personal trainers and a welcoming atmosphere in a relaxed setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-7cfd-768f-b6a9-dbb534a50f99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-7cfd-768f-b6a9-dbb534a50f99",
        "storage_key": "property/6767906449167324/019e1814-7cfd-768f-b6a9-dbb534a50f99.webp",
        "width": 1280,
        "height": 592
      },
      "poi_business_url": "https://leafgym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4864594059118516902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leaf-gym",
      "poi_latitude": "47.4327305",
      "poi_longitude": "-120.3148664",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-300-1675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr7S4fODNm1QRpho85oWCgkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ae66aee6-fdc9-43ee-bc00-76e09c801207",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Kula Hot Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "741 Riverside Dr, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-7d6e-73d3-9f46-a6026a97bf87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-7d6e-73d3-9f46-a6026a97bf87",
        "storage_key": "property/6767906449167324/019e1814-7d6e-73d3-9f46-a6026a97bf87.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://kulahot.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13487973294181417312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kula-hot-yoga",
      "poi_latitude": "47.4354137",
      "poi_longitude": "-120.3160155",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-22c8-77ce-bd03-6a482861ced6",
        "storage_key": "property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8yodOADNm1QRYIGjqz_oLrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_06ef09b7-3921-41ea-b019-96d14619bdf4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Wenatchee Riverfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Apple Capitol Recreational Loop Trail, Wenatchee, WA 98801, USA",
      "poi_short_description": "Picturesque park on the water offering a boat launch, shoreline trail & picnic areas.",
      "poi_long_description": "Picturesque park on the water offering a boat launch, shoreline trail & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-7578-70fb-8e7d-ed65b2d9866d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e4-7578-70fb-8e7d-ed65b2d9866d",
        "storage_key": "property/6767906449167324/019d45e4-7578-70fb-8e7d-ed65b2d9866d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.chelanpud.org/parks-and-recreation/our-parks/day-use-parks/wenatchee-riverfront-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4251592955942674371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wenatchee-riverfront-park",
      "poi_latitude": "47.4305338",
      "poi_longitude": "-120.3105042",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-661-4551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-656b-719d-b623-8f1d55b4efc7",
        "storage_key": "property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjTlIepHMm1QRwx-EfESxADs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e05722dd-9276-4cb7-9be1-f09782c01f63",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Apple Capital Recreational Loop Trailhead - 19th St",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "146 19th St NW, East Wenatchee, WA 98802, USA",
      "poi_short_description": "Park with riverside, paved trails, and fields for softball, plus bike rentals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-3f73-71b6-ad00-7b834664b896.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e6-3f73-71b6-ad00-7b834664b896",
        "storage_key": "property/6767906449167324/019d45e6-3f73-71b6-ad00-7b834664b896.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.chelanpud.org/parks-and-recreation/our-parks/apple-capital-loop-trail",
      "poi_directions_map_url": "https://maps.google.com/?cid=16832835673445526017&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "apple-capital-recreational-loop-trailhead---19th-st",
      "poi_latitude": "47.4340897",
      "poi_longitude": "-120.3015238",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-656b-719d-b623-8f1d55b4efc7",
        "storage_key": "property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw7v7Oo_Mm1QRAWo-Xtw-muk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0db63bd8-c683-4228-babf-c49e969e0ac9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Hale Park Off Leash Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "720 S Worthen St, Wenatchee, WA 98801, USA",
      "poi_short_description": "Fenced-in green space for dogs to run and socialize alongside a river and featuring benches and a water station.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-7d64-726e-a487-57b730851494.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-7d64-726e-a487-57b730851494",
        "storage_key": "property/6767906449167324/019e1814-7d64-726e-a487-57b730851494.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.visitwenatchee.org/listing/hale-park-off-leash-area",
      "poi_directions_map_url": "https://maps.google.com/?cid=13321012716998635508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hale-park-off-leash-area",
      "poi_latitude": "47.4130002",
      "poi_longitude": "-120.2989086",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-656b-719d-b623-8f1d55b4efc7",
        "storage_key": "property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJOf_S8ujMm1QR9C8qBX2-3bg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_42317dd4-d490-4891-96e5-5532a27c0e23",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Walla Walla Point Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1351 Walla Walla Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "Public park with a playground, sports courts, BBQ & swimming areas & paved riverside trails.",
      "poi_long_description": "Public park with a playground, sports courts, BBQ & swimming areas & paved riverside trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-533f-77d5-91ee-a5b6958a13dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e4-533f-77d5-91ee-a5b6958a13dc",
        "storage_key": "property/6767906449167324/019d45e4-533f-77d5-91ee-a5b6958a13dc.webp",
        "width": 3072,
        "height": 2302
      },
      "poi_business_url": "http://www.chelanpud.org/walla-walla-point-park.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7096768437365313985&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walla-walla-point-park",
      "poi_latitude": "47.4439468",
      "poi_longitude": "-120.3186405",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 509-661-8006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-656b-719d-b623-8f1d55b4efc7",
        "storage_key": "property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJv5CKEn3Lm1QRwRFdIkvJfGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9aa048d6-55b7-4dbb-bd9f-87b973149905",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Lincoln Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1410 S Mission St, Wenatchee, WA 98801, USA",
      "poi_short_description": "Kid-friendly green space featuring 3 baseball fields and a disc golf course.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-4983-76cf-8abf-c2a5e7d64fe7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e6-4983-76cf-8abf-c2a5e7d64fe7",
        "storage_key": "property/6767906449167324/019d45e6-4983-76cf-8abf-c2a5e7d64fe7.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "http://www.wenatcheewa.gov/Home/Components/FacilityDirectory/FacilityDirectory/44/1312",
      "poi_directions_map_url": "https://maps.google.com/?cid=14139839854563624748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lincoln-park",
      "poi_latitude": "47.4032781",
      "poi_longitude": "-120.3057421",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 509-888-3284",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-656b-719d-b623-8f1d55b4efc7",
        "storage_key": "property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9b0dfdjMm1QRLActgG7NOsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_91f27805-0400-4d68-883b-937cd5c6c89d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Lions Locomotive Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1100 S Wenatchee Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2438184034316424401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lions-locomotive-park",
      "poi_latitude": "47.410161",
      "poi_longitude": "-120.3008095",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-656b-719d-b623-8f1d55b4efc7",
        "storage_key": "property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8blzPQDNm1QR0ZR1DnYr1iE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3129fb9c-2a99-415b-92b8-895b83dcf56f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Washington Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "110 S Miller St, Wenatchee, WA 98801, USA",
      "poi_short_description": "Child-friendly, shady green space featuring play equipment and shelters, plus picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-826a-77c8-a951-7c36b409514e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-826a-77c8-a951-7c36b409514e",
        "storage_key": "property/6767906449167324/019e1814-826a-77c8-a951-7c36b409514e.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.wenatcheewa.gov/Home/Components/FacilityDirectory/FacilityDirectory/8/1312",
      "poi_directions_map_url": "https://maps.google.com/?cid=6193635056801302189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-park",
      "poi_latitude": "47.42202899999999",
      "poi_longitude": "-120.326082",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 509-888-3284",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-656b-719d-b623-8f1d55b4efc7",
        "storage_key": "property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHxQqErnMm1QRrUYM1UQ29FU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ed6043b3-1510-404d-b71b-2a94c6ad39d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Saddle Rock Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1130 Circle St, Wenatchee, WA 98801, USA",
      "poi_short_description": "Steep hike with scenic views from the top, plus a picnic area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-85a3-754d-97f5-df48c8cf2790.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-85a3-754d-97f5-df48c8cf2790",
        "storage_key": "property/6767906449167324/019e1814-85a3-754d-97f5-df48c8cf2790.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://alltrails.com/trail/us/washington/saddle-rock-nb-310-2013",
      "poi_directions_map_url": "https://maps.google.com/?cid=10820970161958952542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saddle-rock-trailhead",
      "poi_latitude": "47.3970339",
      "poi_longitude": "-120.3298378",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 509-667-9708",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpT1CJSozmlQRXh6qxAfPK5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_4db8e7c8-400d-4925-9008-02fa84b1fbe0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Wenatchee Confluence State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "333 Olds Station Rd, Wenatchee, WA 98801, USA",
      "poi_short_description": "187-acre park offers camping, sports fields, swimming & wetlands at the confluence of 2 rivers.",
      "poi_long_description": "187-acre park offers camping, sports fields, swimming & wetlands at the confluence of 2 rivers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-5d5b-717c-99bf-af5470539f60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e4-5d5b-717c-99bf-af5470539f60",
        "storage_key": "property/6767906449167324/019d45e4-5d5b-717c-99bf-af5470539f60.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://parks.wa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4904638791708676315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wenatchee-confluence-state-park",
      "poi_latitude": "47.46050530000001",
      "poi_longitude": "-120.3272005",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 509-664-6373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-656b-719d-b623-8f1d55b4efc7",
        "storage_key": "property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5VrF9XPLm1QR25Blw_7GEEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_86da47d0-9bd9-4c6c-bab0-65288d20164c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Squilchuck State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2805 Mission Ridge Rd, Wenatchee, WA 98801, USA",
      "poi_short_description": "Mountain bike trails, a sledding hill, and a lodge are among the attractions at this state park.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d4e9c-16e3-71f9-ac4d-9dd924ff5b89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d4e9c-16e3-71f9-ac4d-9dd924ff5b89",
        "storage_key": "property/6767906449167324/019d4e9c-16e3-71f9-ac4d-9dd924ff5b89.webp",
        "width": 2560,
        "height": 1440
      },
      "poi_business_url": "https://parks.wa.gov/find-parks/state-parks/squilchuck-state-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1859854042221139573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "squilchuck-state-park",
      "poi_latitude": "47.30906720000001",
      "poi_longitude": "-120.3728069",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "1 hour 42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 509-664-6373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-656b-719d-b623-8f1d55b4efc7",
        "storage_key": "property/6767906449167324/019d45e4-656b-719d-b623-8f1d55b4efc7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK1dazXAumlQRdVaqwGWHzxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_b832b6bd-ea57-47e1-bd73-ec3232c18d3c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Link Transit Columbia Station - Wenatchee",
      "poi_type": "Transportation & Transit",
      "poi_address": "Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10867731396991085868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "link-transit-columbia-station---wenatchee",
      "poi_latitude": "47.42043899999999",
      "poi_longitude": "-120.307463",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-5b6b-7519-bfbc-1619fbda7739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e6-5b6b-7519-bfbc-1619fbda7739",
        "storage_key": "property/6767906449167324/019d45e6-5b6b-7519-bfbc-1619fbda7739.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJK2KxUurMm1QRLG0DOCDw0ZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_468077e8-58bc-4709-a626-461f23187944",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Wenatchee, Washington Amtrak Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kittitas St & S Columbia St, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-6956-7566-b70c-6706b8b426bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e4-6956-7566-b70c-6706b8b426bf",
        "storage_key": "property/6767906449167324/019d45e4-6956-7566-b70c-6706b8b426bf.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=WEN",
      "poi_directions_map_url": "https://maps.google.com/?cid=1323434861450958820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wenatchee-washington-amtrak-station",
      "poi_latitude": "47.4216446",
      "poi_longitude": "-120.3065713",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-7a33-75fe-9588-0b36e25b6b08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-7a33-75fe-9588-0b36e25b6b08",
        "storage_key": "property/6767906449167324/019d45e4-7a33-75fe-9588-0b36e25b6b08.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_7sCOvMm1QR5BcnoP7IXRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_c89d1590-17b0-464c-be86-32ae3e39c947",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Olds Station Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Penny Rd, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-5d44-721a-91d1-fdb4ddf4bf58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e6-5d44-721a-91d1-fdb4ddf4bf58",
        "storage_key": "property/6767906449167324/019d45e6-5d44-721a-91d1-fdb4ddf4bf58.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.linktransit.com/routes_and_schedules/park_and_rides.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=1615470172654438275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olds-station-park--ride",
      "poi_latitude": "47.46605599999999",
      "poi_longitude": "-120.3300957",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 509-662-1155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-5b78-74a6-a129-8029f0250043.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e6-5b78-74a6-a129-8029f0250043",
        "storage_key": "property/6767906449167324/019d45e6-5b78-74a6-a129-8029f0250043.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJb5pM9wnLm1QRg4dOGpBNaxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_1f50b59e-86e4-484a-8c99-680a7dfd8808",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "310 Rock Island Rd, East Wenatchee, WA 98802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.linktransit.com/routes_and_schedules/park_and_rides.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=16237291778748566963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park--ride",
      "poi_latitude": "47.39957099999999",
      "poi_longitude": "-120.286223",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-5b78-74a6-a129-8029f0250043.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e6-5b78-74a6-a129-8029f0250043",
        "storage_key": "property/6767906449167324/019d45e6-5b78-74a6-a129-8029f0250043.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJIajqbxjNm1QRs82tCthyVuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_c5355a90-8677-4654-a229-0a9041f10381",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Link Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "2700 Euclid Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019e1814-874f-70e1-99b6-4a0f2f89107e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1814-874f-70e1-99b6-4a0f2f89107e",
        "storage_key": "property/6767906449167324/019e1814-874f-70e1-99b6-4a0f2f89107e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.linktransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13206685033488041497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "link-transit",
      "poi_latitude": "47.4665552",
      "poi_longitude": "-120.326968",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 509-662-1155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ08fJKqHLm1QRGcaF4RCSR7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_c5b69cdb-a269-4a95-85db-8d99eabd0ca8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Pangborn Memorial Airport (EAT)",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Pangborn Dr, East Wenatchee, WA 98802, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-6dcf-725e-9690-272bfe47310a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e4-6dcf-725e-9690-272bfe47310a",
        "storage_key": "property/6767906449167324/019d45e4-6dcf-725e-9690-272bfe47310a.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.flywenatchee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16859546850942474455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pangborn-memorial-airport-eat",
      "poi_latitude": "47.40451040000001",
      "poi_longitude": "-120.2102355",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 509-884-2494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-7e7d-7671-a9a0-a3f7cb81efc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-7e7d-7671-a9a0-a3f7cb81efc8",
        "storage_key": "property/6767906449167324/019d45e4-7e7d-7671-a9a0-a3f7cb81efc8.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAWn7nenNm1QR11h7BIkk-ek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_39419fb2-5fb8-489f-873e-fdfaeb29e8cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Wenatchee City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "301 Yakima St, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-73de-76c8-adc9-c34696ef343b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e6-73de-76c8-adc9-c34696ef343b",
        "storage_key": "property/6767906449167324/019d45e6-73de-76c8-adc9-c34696ef343b.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "http://www.wenatcheewa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1961871430226319910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wenatchee-city-hall",
      "poi_latitude": "47.4209067",
      "poi_longitude": "-120.312182",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 509-888-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-70f5-777f-a5ba-0843893aba39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e6-70f5-777f-a5ba-0843893aba39",
        "storage_key": "property/6767906449167324/019d45e6-70f5-777f-a5ba-0843893aba39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaV_8uerMm1QRJpqg3av3ORs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_492caf89-05b4-4bb4-b4d5-8d4aa8614443",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Chelan County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "316 Washington St #301, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-67bc-748a-937e-b4652dadc953.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e6-67bc-748a-937e-b4652dadc953",
        "storage_key": "property/6767906449167324/019d45e6-67bc-748a-937e-b4652dadc953.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.co.chelan.wa.us/superior-court",
      "poi_directions_map_url": "https://maps.google.com/?cid=5705567209624014674&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chelan-county-courthouse",
      "poi_latitude": "47.4217987",
      "poi_longitude": "-120.3155746",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 509-667-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-70f5-777f-a5ba-0843893aba39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e6-70f5-777f-a5ba-0843893aba39",
        "storage_key": "property/6767906449167324/019d45e6-70f5-777f-a5ba-0843893aba39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCScy7L_Mm1QRUo_B0yU_Lk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_3537f1c9-185b-4557-9062-fe96d0da016e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Confluence Health Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 S Miller St, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-52b3-779b-b742-c606dba8fa78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e4-52b3-779b-b742-c606dba8fa78",
        "storage_key": "property/6767906449167324/019d45e4-52b3-779b-b742-c606dba8fa78.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "http://www.confluencehealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3312567822701656849&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "confluence-health-hospital",
      "poi_latitude": "47.4068791",
      "poi_longitude": "-120.3215028",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 509-662-1511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-5fbf-738d-93c1-71e7c63771e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-5fbf-738d-93c1-71e7c63771e4",
        "storage_key": "property/6767906449167324/019d45e4-5fbf-738d-93c1-71e7c63771e4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJY42Qg9HMm1QREXuFTuKa-C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_924d729e-1f6a-4104-9a5b-2b390207e5d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Chelan County PUD (Headquarters)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "203 Olds Station Rd, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-7740-7319-a58e-d55ad0ddff29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d45e6-7740-7319-a58e-d55ad0ddff29",
        "storage_key": "property/6767906449167324/019d45e6-7740-7319-a58e-d55ad0ddff29.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "http://www.chelanpud.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10123369547384452052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chelan-county-pud-headquarters",
      "poi_latitude": "47.46188799999999",
      "poi_longitude": "-120.3342231",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 509-663-8121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-WgzOpfMm1QR1HPbqfdufYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_781a5f5a-1931-4c5b-b493-d2ac3e2b5c30",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Stemilt Growers LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3135 Warehouse Rd, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d4e9c-3d08-76ad-939e-b81c1cac5d36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d4e9c-3d08-76ad-939e-b81c1cac5d36",
        "storage_key": "property/6767906449167324/019d4e9c-3d08-76ad-939e-b81c1cac5d36.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.stemilt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15878722001164754823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stemilt-growers-llc",
      "poi_latitude": "47.4752228",
      "poi_longitude": "-120.3215897",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 509-663-1451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-2a02-7030-93c8-19baebd455ef",
        "storage_key": "property/6767906449167324/019d45e4-2a02-7030-93c8-19baebd455ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa6l64qjLm1QRh9-a7oeNXNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wholesaler"
    },
    {
      "id": "custom_5e69ba78-c973-4d5c-8dfe-6d99c6f763e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Okanogan-Wenatchee National Forest Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "215 Melody Ln, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.fs.usda.gov/r06/okanogan-wenatchee/offices",
      "poi_directions_map_url": "https://maps.google.com/?cid=820326155692692562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "okanogan-wenatchee-national-forest-headquarters",
      "poi_latitude": "47.4700807",
      "poi_longitude": "-120.3368234",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-70f5-777f-a5ba-0843893aba39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e6-70f5-777f-a5ba-0843893aba39",
        "storage_key": "property/6767906449167324/019d45e6-70f5-777f-a5ba-0843893aba39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWZgfxAfLm1QRUlQG1kpiYgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_eaa69db4-ee11-47cd-b575-59916b2c92d1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "Wenatchee School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "235 Sunset Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d4e9c-3fd6-75bd-959a-b77536df3dcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d4e9c-3fd6-75bd-959a-b77536df3dcc",
        "storage_key": "property/6767906449167324/019d4e9c-3fd6-75bd-959a-b77536df3dcc.webp",
        "width": 3072,
        "height": 1921
      },
      "poi_business_url": "http://www.wenatcheeschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16301140800013283610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wenatchee-school-district",
      "poi_latitude": "47.4276661",
      "poi_longitude": "-120.3261972",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 509-663-8161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e4-22c8-77ce-bd03-6a482861ced6",
        "storage_key": "property/6767906449167324/019d45e4-22c8-77ce-bd03-6a482861ced6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-aU6wrzMm1QRGjFrwjBJOeI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1d004f8f-0a2c-486b-a5d9-2ad22e737bdb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "custom",
      "poi_name": "US Forestry Science Lab",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1133 N Western Ave, Wenatchee, WA 98801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.fs.usda.gov/pnw/research-labs/forestry-sciences-laboratory-wenatchee",
      "poi_directions_map_url": "https://maps.google.com/?cid=5594883163323951621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-forestry-science-lab",
      "poi_latitude": "47.4393466",
      "poi_longitude": "-120.3450587",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 509-662-4315",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167324/019d45e6-70f5-777f-a5ba-0843893aba39.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d45e6-70f5-777f-a5ba-0843893aba39",
        "storage_key": "property/6767906449167324/019d45e6-70f5-777f-a5ba-0843893aba39.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUW-WW1nLm1QRBeq8FZgEpU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_3a4e2baaa30e7a405bc84207",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_0324b25fd55320baef5764ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_f86cc1279dd8ae7cedca2877",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_366eaac33fb6a291ef3cbd84",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_8f85783abc9642e5875f43a7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e50e0-dedf-7335-8a79-2ac9a773ac58",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Majestic Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "luxury-apartments-fitness-center-wenatchee-wa",
      "search_query": "luxury apartments with fitness center Wenatchee WA",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center",
      "h2_subtitle": "Discover luxury living in Wenatchee, WA. Our fitness center is just one of the many premium features that make our apartments stand out.",
      "page_copy": "Welcome to The Majestic, where luxury apartments with a fitness center in Wenatchee, WA redefine modern living. Each unit, from cozy studios to expansive three-bedroom layouts, offers a stylish and comfortable living experience. At our state-of-the-art fitness center, residents can enjoy comprehensive workout amenities tailored to suit active lifestyles. \n\nBeyond the fitness center, The Majestic boasts a rooftop deck with scenic views and lounge seating, perfect for relaxation or socializing. Residents also have access to our grand club room—a beautiful space designed for entertainment and leisure. Make The Majestic your home and experience the epitome of luxury living combined with wellness-focused amenities right here in Wenatchee.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Fitness Center",
      "seo_description": "Explore luxury living in Wenatchee, WA. Enjoy The Majestic's fitness center, rooftop deck, and more in our exquisite apartment community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "rooftop-deck-apartments-chelan-county",
      "search_query": "rooftop deck apartments in Chelan County",
      "category": "Amenity",
      "h1_title": "Rooftop Deck Apartments in Chelan County",
      "h2_subtitle": "Experience the charm of Chelan County from our rooftop deck apartments. Enjoy stunning views and premium amenities.",
      "page_copy": "At The Majestic, our rooftop deck apartments in Chelan County offer an unrivaled living experience. Imagine coming home to a stylish apartment, with options ranging from studios to three-bedroom spaces. Each apartment is designed with modern elegance and comfort in mind, providing a perfect backdrop for your lifestyle. \n\nOur rooftop deck isn't just a feature—it's a lifestyle. With lounge seating and grills, it’s an ideal venue for relaxation or entertaining friends. As a resident of The Majestic, you'll also enjoy access to a state-of-the-art fitness center and our grand club room, creating a community where leisure and luxury blend seamlessly. Discover the best of Chelan County living today at The Majestic.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rooftop Deck Apartments Chelan County",
      "seo_description": "Discover Chelan County living at The Majestic. Enjoy our rooftop deck with stunning views, lounge seating, and upscale amenities in Wenatchee, WA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "apartments-club-room-amenities-98801",
      "search_query": "apartments with club room amenities 98801",
      "category": "Amenity",
      "h1_title": "Apartments with Club Room Amenities",
      "h2_subtitle": "Explore premier apartment living with club room amenities in the 98801 area. Unwind and socialize in style at The Majestic.",
      "page_copy": "Experience the ultimate in apartment living at The Majestic, featuring top-tier amenities, including an expansive club room, right in the heart of Wenatchee, WA. Our community offers a variety of floor plans from cozy studios to spacious three-bedroom layouts, tailored to fit your lifestyle. \n\nThe grand club room serves as a central hub for residents—a perfect place to relax, host gatherings, or meet new friends. Additional amenities include a rooftop deck with stunning views and a state-of-the-art fitness center. Located in the bustling 98801 area, The Majestic delivers a perfect blend of luxury, comfort, and convenience. Come home to refined living today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Club Room Amenities",
      "seo_description": "Look no further than The Majestic for apartments with excellent club room amenities in the 98801 area. Discover your new home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "modern-wenatchee-apartments-rooftop-views",
      "search_query": "modern Wenatchee apartments with rooftop views",
      "category": "Amenity",
      "h1_title": "Modern Wenatchee Apartments with Rooftop Views",
      "h2_subtitle": "Discover the beauty of modern Wenatchee living. Our apartments offer stunning rooftop views in a stylish setting at The Majestic.",
      "page_copy": "Welcome to The Majestic, where modern Wenatchee apartments with rooftop views redefine your living experience. Choose from a range of thoughtfully designed floor plans, from stylish studios to spacious three-bedroom homes, each tailored with modern amenities and finishes to enhance your comfort.\n\nOur rooftop deck is the highlight, providing panoramic views of Wenatchee, perfect for soaking up the scenery or enjoying a relaxed evening with friends. In addition to breathtaking rooftop views, residents benefit from our state-of-the-art fitness center and an elegant grand club room. Experience modern living with a view at The Majestic—a community that seamlessly blends elevated style and convenience in Wenatchee.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Rooftop Views",
      "seo_description": "Experience modern living with spectacular rooftop views at The Majestic in Wenatchee. Discover our stylish apartments and premium amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "fitness-center-apartment-living-wenatchee",
      "search_query": "fitness center apartment living in Wenatchee",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartment Living in Wenatchee",
      "h2_subtitle": "Embrace a lifestyle of wellness at The Majestic with our state-of-the-art fitness center in Wenatchee's vibrant community.",
      "page_copy": "The Majestic offers the pinnacle of fitness center apartment living in Wenatchee. Our state-of-the-art fitness facility is designed to support your health and wellness goals, equipped with advanced exercise machines and spaces crafted to inspire your daily workouts. \n\nChoose from a variety of floor plans, from chic studios to spacious three-bedroom apartments, each designed with modern comfort in mind. Apart from staying fit, residents enjoy our grand club room and the stunning rooftop deck, perfect for socializing or unwinding. Situated in beautiful Wenatchee, The Majestic combines convenience, luxury, and an active lifestyle. Discover a community that prioritizes your well-being today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Wenatchee",
      "seo_description": "Discover active living at The Majestic with a state-of-the-art fitness center and luxurious apartment amenities in Wenatchee.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "studio-apartments-wenatchee-wa",
      "search_query": "studio apartments Wenatchee WA",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Wenatchee, WA",
      "h2_subtitle": "Find your perfect home with our stylish studio apartments in Wenatchee, WA. Experience comfort and modern living at The Majestic.",
      "page_copy": "Welcome to The Majestic, where you can find stylish studio apartments in Wenatchee, WA. Our thoughtfully designed studio spaces offer the perfect blend of modern comfort and convenience, ideal for individuals seeking a cozy, efficient home in a vibrant community.\n\nAt The Majestic, residents not only enjoy beautifully appointed studios but also have access to premium amenities such as a grand club room, a state-of-the-art fitness center, and a rooftop deck offering stunning views of Wenatchee. Embrace a lifestyle that fits your needs and discover why our studio apartments are the perfect choice for those looking to settle in Wenatchee.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Wenatchee, WA",
      "seo_description": "Explore stylish studio apartments at The Majestic in Wenatchee, WA. Enjoy modern living with fantastic amenities and community features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-near-98801",
      "search_query": "one bedroom apartments near 98801",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Near 98801",
      "h2_subtitle": "Discover spacious one bedroom apartments near 98801 at The Majestic. Enjoy modern amenities and a central Wenatchee location.",
      "page_copy": "For those searching for one bedroom apartments near 98801, The Majestic is the perfect choice. Located in the heart of Wenatchee, our one-bedroom homes offer a blend of comfort and modern style, showcasing ample living spaces and high-quality finishes.\n\nResidents benefit from our top-notch amenities, including a state-of-the-art fitness center, an inviting grand club room, and a beautiful rooftop deck with panoramic views. The Majestic provides a peaceful residential atmosphere while keeping you connected to the vibrant city of Wenatchee. Find your ideal one-bedroom apartment today in a community designed for living well.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Near 98801",
      "seo_description": "Explore The Majestic's one bedroom apartments near 98801 in Wenatchee. Enjoy modern amenities and a central location for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-chelan-county",
      "search_query": "two bedroom apartments in Chelan County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Chelan County",
      "h2_subtitle": "Explore spacious two bedroom apartments in Chelan County at The Majestic, offering modern amenities and a vibrant community setting.",
      "page_copy": "The Majestic proudly offers two bedroom apartments in Chelan County, perfect for those seeking a blend of convenience and contemporary living. Our spacious layouts feature open-plan designs and exquisite finishes, ideal for families or roommates looking for a comfortable and modern home environment.\n\nBeyond the beautiful apartment interiors, enjoy our community perks such as a state-of-the-art fitness center and a welcoming grand club room. Unwind at the end of the day on our rooftop deck, which offers stunning views of the surrounding Chelan County. Experience unparalleled apartment living at The Majestic, where style meets practicality in a vibrant setting.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Chelan County",
      "seo_description": "Discover modern two bedroom apartments at The Majestic in Chelan County, featuring spacious layouts and a host of premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-wenatchee",
      "search_query": "three bedroom apartments in Wenatchee",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Wenatchee",
      "h2_subtitle": "Find expansive three bedroom apartments in Wenatchee at The Majestic. Experience modern living with top-tier amenities.",
      "page_copy": "At The Majestic, our three bedroom apartments in Wenatchee offer an ideal blend of luxury and convenience. Perfect for larger families or those needing extra space, these apartments feature expansive layouts with high-quality finishes and thoughtful design elements.\n\nEnjoy unmatched community amenities including a sophisticated grand club room, a cutting-edge fitness center, and a scenic rooftop deck perfect for entertaining. Situated in the heart of Wenatchee, The Majestic is where premium living meets community charm. Check availability today and discover the benefits of a three-bedroom lifestyle in our welcoming community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Wenatchee",
      "seo_description": "Explore The Majestic's spacious three bedroom apartments in Wenatchee, offering modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "apartments-near-washington-elementary-school-wenatchee",
      "search_query": "apartments near washington elementary school wenatchee",
      "category": "School",
      "h1_title": "Apartments Near Washington Elementary School",
      "h2_subtitle": "Discover modern apartments near Washington Elementary School in Wenatchee at The Majestic. Enjoy family-friendly living with top amenities.",
      "page_copy": "The Majestic is an excellent choice for families seeking apartments near Washington Elementary School in Wenatchee. Our property offers a variety of floor plans, ensuring a comfortable fit for any family dynamic. With proximity to the school, morning routines are simplified, providing convenience and peace of mind for parents.\n\nResidents of The Majestic enjoy a bounty of amenities, including a state-of-the-art fitness center, an elegant grand club room, and a panoramic rooftop deck. Our community strikes the perfect balance between family living and modern convenience, making it an ideal home base in Wenatchee. Explore all that The Majestic has to offer and find the perfect home near Washington Elementary School today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Washington Elementary School",
      "seo_description": "Find modern family-friendly apartments near Washington Elementary School in Wenatchee at The Majestic, featuring top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "rentals-near-mission-view-elementary-school-98801",
      "search_query": "rentals near mission view elementary school 98801",
      "category": "School",
      "h1_title": "Rentals Near Mission View Elementary School",
      "h2_subtitle": "Discover spacious rentals near Mission View Elementary School 98801 at The Majestic. Ideal for families seeking convenience and modern amenities.",
      "page_copy": "Located in the heart of Wenatchee, The Majestic offers excellent rentals near Mission View Elementary School 98801. Our variety of apartment layouts accommodate families looking for comfort, convenience, and proximity to quality education. Enjoy easy commutes and a tight-knit community atmosphere, perfect for families.\n\nAt The Majestic, residents benefit from a host of amenities, including a state-of-the-art fitness center, grand club room, and a stunning rooftop deck. These features, combined with our prime location, make The Majestic an ideal choice for families seeking rentals near Mission View Elementary School. Discover what life can be like at The Majestic—where community spirit and modern living go hand in hand.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Mission View Elementary School",
      "seo_description": "Explore family-friendly rentals near Mission View Elementary School 98801 at The Majestic, offering modern amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "apartments-close-to-john-newbery-elementary-school-chelan-county",
      "search_query": "apartments close to john newbery elementary school chelan county",
      "category": "School",
      "h1_title": "Apartments Close to John Newbery Elementary",
      "h2_subtitle": "Explore The Majestic's apartments close to John Newbery Elementary School in Chelan County. Perfect for families seeking convenience and style.",
      "page_copy": "The Majestic offers prime apartments close to John Newbery Elementary School, nestled in beautiful Chelan County. Our community provides families with easy access to quality education, making mornings smoother and commutes shorter. Tailored for comfort and convenience, our diverse range of apartments are well-suited for family living.\n\nBeyond location, residents enjoy exclusive amenities like a rooftop deck with picturesque views, a modern fitness center, and a grand club room designed for relaxation and social gatherings. Choose The Majestic for a seamless blend of community, convenience, and contemporary living, all just steps from John Newbery Elementary School.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to John Newbery Elementary",
      "seo_description": "Discover The Majestic's family-friendly apartments close to John Newbery Elementary School in Chelan County, with modern amenities and community charm.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "majestic-rentals-near-lewis-clark-elementary-wa",
      "search_query": "the majestic rentals near lewis & clark elementary school wa",
      "category": "School",
      "h1_title": "The Majestic Rentals Near Lewis & Clark Elementary",
      "h2_subtitle": "Find exceptional rentals at The Majestic near Lewis & Clark Elementary School in WA. Enjoy top amenities and family-focused living.",
      "page_copy": "The Majestic provides family-friendly rentals near Lewis & Clark Elementary School in WA, offering a perfect home base with quick access to premier education. Our thoughtfully designed apartments cater to both families seeking comfort and professionals desiring convenience.\n\nResidents enjoy unmatched amenities such as a state-of-the-art fitness center, a grand club room, and a splendid rooftop deck. The Majestic combines modern living with a family-oriented environment, making it an ideal choice for those looking for rentals near Lewis & Clark Elementary School in WA. Experience vibrant community living while ensuring educational excellence is just around the corner.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Majestic Rentals Near Lewis & Clark Elementary",
      "seo_description": "Find The Majestic's rentals near Lewis & Clark Elementary School in WA. Enjoy family-friendly living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "apartments-near-lincoln-elementary-school-wenatchee-wa",
      "search_query": "apartments near lincoln elementary school wenatchee wa",
      "category": "School",
      "h1_title": "Apartments near Lincoln Elementary School",
      "h2_subtitle": "Discover The Majestic's apartments near Lincoln Elementary School in Wenatchee, WA. Perfect for families desiring close-knit community living.",
      "page_copy": "Located in vibrant Wenatchee, The Majestic offers excellent apartments near Lincoln Elementary School. Enjoy the benefits of a short commute and a supportive community environment, making it an ideal choice for families seeking educational convenience without sacrificing modern amenities.\n\nResidents at The Majestic benefit from an array of premium amenities such as our rooftop deck with stunning views, a state-of-the-art fitness center, and a relaxing grand club room. Choosing The Majestic means access to quality education and the enjoyment of a lively, well-connected lifestyle near Lincoln Elementary School in Wenatchee, WA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments near Lincoln Elementary School",
      "seo_description": "Explore The Majestic's family-friendly apartments near Lincoln Elementary School in Wenatchee, WA, offering convenience and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "housing-near-orchard-middle-school-wenatchee",
      "search_query": "housing near orchard middle school wenatchee",
      "category": "School",
      "h1_title": "Housing Near Orchard Middle School",
      "h2_subtitle": "Explore The Majestic's housing options near Orchard Middle School in Wenatchee, offering a blend of convenience and modern amenities.",
      "page_copy": "The Majestic in Wenatchee offers ideal housing near Orchard Middle School, making it a prime choice for families and professionals seeking proximity to quality education. With our range of stylish studio to three-bedroom floor plans, there's a perfect fit for everyone looking to call Wenatchee home.\n\nResidents at The Majestic enjoy relaxing amenities like our grand club room, state-of-the-art fitness center, and a rooftop deck with breathtaking city views. Living near Orchard Middle School allows for enhanced lifestyle flexibility, ensuring that every family enjoys both convenience and a supportive community atmosphere.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Orchard Middle School",
      "seo_description": "Discover The Majestic's housing near Orchard Middle School in Wenatchee, offering family-friendly living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "apartments-close-to-foothills-middle-school-chelan-county",
      "search_query": "apartments close to foothills middle school chelan county",
      "category": "School",
      "h1_title": "Apartments Close to Foothills Middle School",
      "h2_subtitle": "The Majestic offers modern apartments close to Foothills Middle School in Chelan County, ideal for families seeking educational closeness.",
      "page_copy": "Nestled in Chelan County, The Majestic provides exceptional apartment living close to Foothills Middle School. Our location offers easy access to educational institutions while seamlessly integrating modern lifestyle amenities. Excellent for families wanting proximity to school without sacrificing comfort and style.\n\nAt The Majestic, residents can relish in premium amenities including a spacious rooftop deck, a grand club room, and a state-of-the-art fitness center. Our community fosters a vibrant living experience, making The Majestic the preferred choice for those looking for quality apartments close to Foothills Middle School in Chelan County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Foothills Middle School",
      "seo_description": "Live at The Majestic, offering family-friendly apartments close to Foothills Middle School in Chelan County, with modern amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "rentals-near-wenatchee-high-school-washington",
      "search_query": "rentals near wenatchee high school washington",
      "category": "School",
      "h1_title": "Rentals Near Wenatchee High School",
      "h2_subtitle": "Discover convenient rentals near Wenatchee High School at The Majestic, offering a modern living experience in Washington.",
      "page_copy": "Located in the heart of Washington, The Majestic provides perfectly situated rentals near Wenatchee High School. Our community is ideally positioned for students and families who value proximity to quality education with the benefit of modern and stylish accommodations.\n\nFeaturing a range of floor plans from efficient studios to large three-bedroom apartments, The Majestic meets diverse needs. Residents can enjoy top-notch amenities such as our grand club room and a stunning rooftop deck. These rentals near Wenatchee High School combine location convenience with unparalleled living spaces, making them an excellent choice in Washington.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Wenatchee High School",
      "seo_description": "Explore The Majestic's rentals near Wenatchee High School, Washington. Enjoy modern living with easy access to education and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "apartments-near-wenatchee-valley-college-98801",
      "search_query": "apartments near wenatchee valley college 98801",
      "category": "School",
      "h1_title": "Apartments Near Wenatchee Valley College",
      "h2_subtitle": "Find stylish apartments near Wenatchee Valley College at The Majestic, located in the vibrant 98801 area.",
      "page_copy": "The Majestic offers premium apartment living just moments from Wenatchee Valley College, making it a prime choice for students and faculty in the 98801 area. With a selection of floor plans ranging from studios to spacious three-bedroom apartments, we cater to your distinct needs.\n\nOur residents enjoy access to a superb range of amenities, including a state-of-the-art fitness center, a grand club room, and a rooftop deck with stunning views. Living in our apartments near Wenatchee Valley College ensures you stay connected to educational opportunities while enjoying a modern, comfortable lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wenatchee Valley College",
      "seo_description": "Discover The Majestic's apartments near Wenatchee Valley College in the 98801 area, offering modern amenities and convenient access to education.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "apartments-near-wenatchee-riverfront-park",
      "search_query": "apartments near Wenatchee Riverfront Park",
      "category": "Park",
      "h1_title": "Apartments Near Wenatchee Riverfront Park",
      "h2_subtitle": "The Majestic boasts modern apartments near Wenatchee Riverfront Park, perfect for outdoor enthusiasts and nature lovers.",
      "page_copy": "The Majestic in Wenatchee offers an ideal location for those who love the outdoors, with apartments conveniently near Wenatchee Riverfront Park. This prime location ensures residents have quick access to serene walking trails and vibrant community events at the park, enriching their living experience.\n\nOur well-appointed community includes a variety of floor plan options, from cozy studios to expansive three-bedroom apartments, ensuring every lifestyle is catered for. Alongside our proximity to nature, The Majestic features outstanding amenities like a rooftop deck and a state-of-the-art fitness center, making it the perfect blend of nature and luxury living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wenatchee Riverfront Park",
      "seo_description": "Live at The Majestic, offering convenient access to Wenatchee Riverfront Park, with modern apartments and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "living-near-apple-capital-recreational-loop-trailhead",
      "search_query": "living near Apple Capital Recreational Loop Trailhead",
      "category": "Park",
      "h1_title": "Living Near Apple Capital Loop Trailhead",
      "h2_subtitle": "Experience living near the Apple Capital Recreational Loop Trailhead at The Majestic, where outdoor adventures meet home comfort.",
      "page_copy": "Reside at The Majestic, perfectly positioned for those who cherish the outdoors, with living options near the Apple Capital Recreational Loop Trailhead. This location is ideal for hiking enthusiasts and fitness lovers who want immediate access to scenic trails every day.\n\nOur luxurious community offers various apartment styles, from intimate studios to expansive three-bedroom layouts. Complementing this fantastic location are our top-notch amenities, including a grand club room and a rooftop deck perfect for relaxation after a day on the trails. Embark on an enriching lifestyle at The Majestic, just steps from the renowned Apple Capital Loop.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Apple Capital Loop Trailhead",
      "seo_description": "Discover The Majestic's premium living options near the Apple Capital Recreational Loop Trailhead, blending luxury amenities with nature access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "the-majestic-near-hale-park-off-leash-area",
      "search_query": "The Majestic near Hale Park Off Leash Area",
      "category": "Park",
      "h1_title": "The Majestic Near Hale Park Off Leash Area",
      "h2_subtitle": "Explore The Majestic, conveniently located near Hale Park Off Leash Area, ideal for pet lovers seeking comfort and community.",
      "page_copy": "Welcome to The Majestic, where pet-friendly living is enhanced by our proximity to the Hale Park Off Leash Area. This location is a dream for dog owners looking to enjoy quality time with their furry friends just a short walk from home.\n\nOur community offers an array of apartment options ranging from studios to three-bedroom units, each designed with your comfort in mind. In addition to the nearby park, enjoy unparalleled amenities at The Majestic such as a rooftop deck and a state-of-the-art fitness center. Experience the best of pet-friendly, modern living at The Majestic.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Majestic Near Hale Park Off Leash Area",
      "seo_description": "Live at The Majestic, near Hale Park Off Leash Area, offering pet-friendly apartments and modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "apartments-by-walla-walla-point-park-wenatchee",
      "search_query": "apartments by Walla Walla Point Park Wenatchee",
      "category": "Park",
      "h1_title": "Apartments by Walla Walla Point Park",
      "h2_subtitle": "Discover apartments near Walla Walla Point Park at The Majestic, offering a stunning blend of nature and comfort.",
      "page_copy": "The Majestic provides the perfect home base for outdoor enthusiasts and nature admirers with its prime location near Walla Walla Point Park in Wenatchee. Enjoy immediate access to beautiful landscapes and recreational activities, right outside your door.\n\nChoose from our thoughtfully designed studio to three-bedroom apartments, each offering luxurious touches and practical amenities. Beyond the park, enjoy our grand club room and rooftop deck, making The Majestic an unbeatable place to call home. Dive into a life of leisure and convenience, nestled close to Walla Walla Point Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Walla Walla Point Park",
      "seo_description": "Live at The Majestic, featuring apartments by Walla Walla Point Park, combining nature's beauty with modern amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "residence-near-lincoln-park-chelan-county",
      "search_query": "residence near Lincoln Park Chelan County",
      "category": "Park",
      "h1_title": "Residence Near Lincoln Park Chelan County",
      "h2_subtitle": "Explore The Majestic, offering residences near Lincoln Park in Chelan County, where community and nature unite.",
      "page_copy": "At The Majestic, enjoy a residence perfectly situated near the charming Lincoln Park in Chelan County, ideal for those who appreciate serene living spaces. This location provides easy access to outdoor activities and peaceful strolls, creating an idyllic environment.\n\nSelect from our versatile apartment layouts, ranging from studios to three-bedroom units, each equipped with premium features for a comfortable living experience. Enjoy additional onsite amenities like our spacious rooftop deck and fully-equipped fitness center, making The Majestic the prime choice for those who seek both relaxation and recreation close to Lincoln Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residence Near Lincoln Park Chelan County",
      "seo_description": "Discover residences at The Majestic near Lincoln Park, Chelan County. Enjoy modern living with access to community attractions and peaceful parks.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "close-to-lions-locomotive-park-homes",
      "search_query": "close to Lions Locomotive Park homes",
      "category": "Park",
      "h1_title": "Close to Lions Locomotive Park Homes",
      "h2_subtitle": "Discover homes at The Majestic, located close to Lions Locomotive Park, ideal living for park enthusiasts and families.",
      "page_copy": "Nestled in the vibrant community of Wenatchee, The Majestic offers homes that are wonderfully close to Lions Locomotive Park. This appealing location is perfect for families and individuals looking to enjoy outdoor activities and local attractions.\n\nOur selection of stylish studio to spacious three-bedroom apartments provides a contemporary lifestyle with premium amenities. Residents can enjoy a fitness center and a rooftop deck with spectacular views, all while living just a short distance from the charming Lions Locomotive Park. Experience the blend of convenience and leisure at The Majestic.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Close to Lions Locomotive Park Homes",
      "seo_description": "Live at The Majestic, close to Lions Locomotive Park. Enjoy modern homes with top amenities in a location perfect for families and park lovers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "apartments-washington-park-wa",
      "search_query": "apartments Washington Park WA",
      "category": "Park",
      "h1_title": "Apartments Near Washington Park WA",
      "h2_subtitle": "Explore The Majestic, offering top-tier apartments near Washington Park, WA, perfect for urban and nature enthusiasts.",
      "page_copy": "The Majestic in Wenatchee brings you the best of both worlds with apartments near Washington Park, WA. Our community is designed for those who crave a blend of modern living and easy access to one of the area's most beloved parks.\n\nChoose from a variety of floor plans, from cozy studios to expansive three-bedroom apartments, all featuring premium finishes. Residents can take advantage of our exceptional amenities, including a state-of-the-art fitness center and a stunning rooftop deck. Experience convenience and comfort at The Majestic, all within reach of Washington Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Washington Park WA",
      "seo_description": "Discover The Majestic, with modern apartments near Washington Park, WA, offering luxurious amenities and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "the-majestic-near-wenatchee-confluence-state-park",
      "search_query": "The Majestic near Wenatchee Confluence State Park",
      "category": "Park",
      "h1_title": "The Majestic Near Wenatchee Confluence State Park",
      "h2_subtitle": "Live at The Majestic, perfectly positioned near Wenatchee Confluence State Park for unparalleled outdoor experiences.",
      "page_copy": "The Majestic offers premier living just a stone's throw away from the picturesque Wenatchee Confluence State Park. This ideal location is perfect for nature lovers and those who appreciate scenic views and outdoor recreation opportunities right at their doorstep.\n\nOur selection of stylish studio, one-, two-, and three-bedroom apartments provides modern amenities, including a rooftop deck and a state-of-the-art fitness center. Embrace the tranquility and excitement of having easy access to hiking trails, biking paths, and water activities while enjoying the comforts of luxury living at The Majestic.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Majestic Near Wenatchee Confluence State Park",
      "seo_description": "Experience The Majestic, near Wenatchee Confluence State Park. Enjoy luxurious living with access to outdoor attractions and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167324",
      "source": "generator",
      "page_item_url": "living-near-squilchuck-state-park-98801",
      "search_query": "living near Squilchuck State Park 98801",
      "category": "Park",
      "h1_title": "Living Near Squilchuck State Park 98801",
      "h2_subtitle": "Experience living near Squilchuck State Park in 98801 at The Majestic. Enjoy both nature and premium amenities.",
      "page_copy": "Discover the unmatched lifestyle of living near Squilchuck State Park, right here at The Majestic in Wenatchee's 98801 area. Perfectly positioned for those who relish outdoor adventures, our community offers both tranquility and excitement.\n\nChoose from beautifully designed studios, or more spacious one- to three-bedroom apartments, equipped with top-notch amenities like a state-of-the-art fitness center and a panoramic rooftop deck. With Squilchuck State Park just a short drive away, enjoy hiking, biking, and the natural beauty of Washington while making The Majestic your home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Squilchuck State Park 98801",
      "seo_description": "Enjoy The Majestic, with modern living near Squilchuck State Park, 98801. Luxury amenities meet outdoor adventure in Wenatchee, WA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6083"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11643110306"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KHJXZNK6"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Via6"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Via6"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "53528450118"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/zlpor9onpg4"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImNZSkVwSlFZaWFnYm44aTlUaWgraGc9PSIsInZhbHVlIjoieUhmMU9LQ00yQmppS2UwNDlpcWxvUT09IiwibWFjIjoiMWE2N2VmM2U5N2E5ZmI3MDllODYzNDY3YWFiYTQzNmQ0YTk3MzEzNDAwY2QyMTQ1NmYxMDk0ZTZjN2FkNTBhOCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "6083",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11643110306",
  "custom_google_gtm_id": "GTM-KHJXZNK6",
  "custom_rollout_phase": "Via6",
  "custom_vibesites_theme": "Via6",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "53528450118",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/zlpor9onpg4",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImNZSkVwSlFZaWFnYm44aTlUaWgraGc9PSIsInZhbHVlIjoieUhmMU9LQ00yQmppS2UwNDlpcWxvUT09IiwibWFjIjoiMWE2N2VmM2U5N2E5ZmI3MDllODYzNDY3YWFiYTQzNmQ0YTk3MzEzNDAwY2QyMTQ1NmYxMDk0ZTZjN2FkNTBhOCJ9",
  "custom_audioeye_site_id": "3028cb81-6e01-4cbd-9d38-58fd296944f2",
  "custom_audioeye_site_hash": "5b3e8f74fc7fa3eef1f767c869ede6ca"
};

export const generatedAt = '2026-10-29T23:20:12.536Z';
